(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 38849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgVergleichangebot = function SvgVergleichangebot(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 284.5 285",
    style: {
      enableBackground: "new 0 0 284.5 285"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M273.6 201.9c0 20-9.8 38.7-26.3 50.1l-30 20.8-30-20.8c-16.4-11.4-26.3-30.1-26.3-50.1v-44.8c21.1 1.4 41.6-6.5 56.2-21.6 14.7 15.2 35.2 23 56.2 21.6v44.8zM11.1 11.3h154.7v42.2c0 2.6 2.1 4.7 4.7 4.7h42.2v68.5c-13.7 15.6-33.9 23.4-54.5 20.8l-1.2-.1c-.2 0-.4.1-.6.1v-.1h-46.9v9.4h42.2v9.4h-75v9.4h75V199H95.5v9.4h56.6c.3 3.2.7 6.3 1.4 9.4H29.9v9.4h126.5c1.2 3.2 2.8 6.4 4.5 9.4h-37.2v9.4h43.6c4.2 5.3 9.1 10.1 14.8 14l20.3 14.1H11.1V11.3zm195 37.5h-30.9V17.9l30.9 30.9zm75.3 99.6c-1-.9-2.3-1.3-3.7-1.1l-1.2.1c-20.6 2.6-40.9-5.2-54.5-20.8V53.4c0-.1-.1-.2-.1-.3 0-.4-.1-.8-.2-1.2-.1-.1-.1-.3-.2-.4-.2-.5-.5-1-.9-1.4L173.8 3.3c-.4-.4-.9-.7-1.4-.9-.1-.1-.3-.1-.5-.2-.3-.2-.7-.2-1.1-.2-.1 0-.2-.1-.3-.1H6.4C3.9 1.9 1.8 4 1.8 6.6v271.9c0 2.6 2.1 4.7 4.7 4.7h210.9c.9 0 1.9-.3 2.7-.8l32.7-22.6c19-13.1 30.3-34.7 30.3-57.8v-50c-.1-1.5-.7-2.7-1.7-3.6"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M254.9 201.9c0 13.8-6.8 26.8-18.2 34.7L217.4 250l-19.3-13.4c-11.4-7.9-18.2-20.9-18.2-34.7v-27c13.5-2.1 26.3-7.2 37.5-15 11.2 7.7 24 12.9 37.5 15v27zm5.2-35.8c-14.5-1.6-28.3-7-39.9-15.7-1.7-1.2-4-1.2-5.6 0-11.6 8.7-25.4 14.2-39.9 15.7-2.4.3-4.2 2.2-4.2 4.6v31.1c0 16.9 8.3 32.8 22.2 42.4l22 15.2c.8.5 1.7.8 2.7.8s1.9-.3 2.7-.8l22-15.2c13.9-9.6 22.2-25.5 22.2-42.4v-31.1c-.1-2.3-1.9-4.3-4.2-4.6"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m196.7 209.1-5.6 7.5 18.8 14.1c.8.6 1.8.9 2.8.9 1.4 0 2.8-.6 3.7-1.8l32.8-42.2-7.4-5.8-30 38.5-15.1-11.2M147.1 25.3h-75v9.4h75v-9.4M147.1 44.1h-75v9.4h75v-9.4M100.2 72.2H29.9v9.4h70.3v-9.4M123.6 90.9H29.9v9.4h93.8v-9.4M118.9 109.7h-89v9.4H119v-9.4M109.6 81.6H194v-9.4h-84.4v9.4M133 100.3h60.9v-9.4H133v9.4M133 109.7h-4.7v9.4h65.6v-9.4H133M193.9 128.4h-164v9.4H194v-9.4M100.2 147.2H29.9v9.4h70.3v-9.4M86.1 198.8H29.9v9.4h56.2v-9.4M67.4 165.9H29.9v9.4h37.5v-9.4M29.9 245.6h84.4v-9.4H29.9v9.4"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgVergleichangebot);

/***/ }),

/***/ 55500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M29.334 3H25V1a1 1 0 1 0-2 0v2h-6V1a1 1 0 1 0-2 0v2H9V1a1 1 0 1 0-2 0v2H2.667A2.666 2.666 0 0 0 0 5.666v23.667A2.667 2.667 0 0 0 2.667 32h26.667A2.666 2.666 0 0 0 32 29.333V5.666A2.665 2.665 0 0 0 29.334 3zM30 29.333a.667.667 0 0 1-.666.667H2.667A.667.667 0 0 1 2 29.333V5.666C2 5.299 2.299 5 2.667 5H7v2a1 1 0 1 0 2 0V5h6v2a1 1 0 1 0 2 0V5h6v2a1 1 0 1 0 2 0V5h4.334c.367 0 .666.299.666.666v23.667zM7 12h4v3H7zm0 5h4v3H7zm0 5h4v3H7zm7 0h4v3h-4zm0-5h4v3h-4zm0-5h4v3h-4zm7 10h4v3h-4zm0-5h4v3h-4zm0-5h4v3h-4z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgCalendar);

/***/ }),

/***/ 78581:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(53536);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SwiperOfferSlider; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88494);
/* harmony import */ var swiper_css_bundle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72821);
/* harmony import */ var swiper_css_bundle__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(swiper_css_bundle__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(965);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);

// eslint-disable-next-line import/no-unresolved

// eslint-disable-next-line import/no-unresolved




function SwiperOfferSlider(param) {
    var items = param.items;
    var ref;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: items && items.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .Swiper */ .tq, {
            slidesPerView: 3,
            spaceBetween: 10,
            loop: true,
            breakpoints: {
                '@0.1': {
                    slidesPerView: 1
                },
                '@0.75': {
                    slidesPerView: 2
                },
                '@1.00': {
                    slidesPerView: 3
                }
            },
            modules: [
                swiper__WEBPACK_IMPORTED_MODULE_3__/* .Navigation */ .W_
            ],
            navigation: true,
            className: "w-full",
            children: items.map(function(item, k) {
                var ref2, ref1;
                // eslint-disable-next-line react/jsx-no-useless-fragment
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: item.thumbnail.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_1__/* .SwiperSlide */ .o5, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_5__["default"], {
                            href: item.link,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "relative group h-[250px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                            src: item.thumbnail[0].publicUrl,
                                            alt: (ref = (ref2 = item.thumbnail[0]) === null || ref2 === void 0 ? void 0 : (ref1 = ref2.properties) === null || ref1 === void 0 ? void 0 : ref1.alternative) !== null && ref !== void 0 ? ref : '',
                                            layout: "fill",
                                            objectFit: "cover"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "absolute text-primary z-20 bg-action group-hover:bg-primary group-hover:text-action right-0 bottom-0 px-3 py-2",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "cms-offer-text",
                                                dangerouslySetInnerHTML: {
                                                    __html: item.offer
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }, k)
                });
            })
        })
    }));
};


/***/ }),

/***/ 11429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DatePicker; }
/* harmony export */ });
/* unused harmony export HORIZONTAL_ORIENTATION */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_dates__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76141);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _globals_input_wrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75565);
/* harmony import */ var _public_assets_icons_anker_calendar_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55500);






var HORIZONTAL_ORIENTATION = 'horizontal';
function DatePicker(param1) {
    var inputDate = param1.inputDate, setValue = param1.setValue, onDateChange = param1.onDateChange;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(inputDate ? moment__WEBPACK_IMPORTED_MODULE_3___default()(inputDate) : null), date1 = ref[0], setDate = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), focusedInput = ref1[0], setFocusedInput = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        return function() {
            return setDate(null);
        };
    }, []);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_globals_input_wrapper__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_assets_icons_anker_calendar_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                className: "absolute right-0 z-10 w-5 h-6 pointer-events-none fill-action top-3 left-2"
            }),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_dates__WEBPACK_IMPORTED_MODULE_1__.SingleDatePicker, {
                date: date1,
                focused: focusedInput,
                firstDayOfWeek: 1,
                id: "date-range-picker-id",
                placeholder: "Fr\xfcheste Abfahrt",
                hideKeyboardShortcutsPanel: true,
                readOnly: true,
                phrases: {
                    closeDatePicker: 'Close',
                    clearDates: 'Clear'
                },
                displayFormat: "DD. MMMM YYYY",
                numberOfMonths: 1,
                orientation: HORIZONTAL_ORIENTATION,
                onDateChange: function(date) {
                    setValue('date_from', date ? date.format('YYYY-MM-DD') : '');
                    setDate(date);
                    onDateChange(date);
                },
                onFocusChange: function(param) {
                    var focused = param.focused;
                    return setFocusedInput(focused);
                }
            })
        })
    }));
};


/***/ }),

/***/ 52800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Dropdown; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86215);
/* harmony import */ var _heroicons_react_solid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13342);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Dropdown(_param) {
    var icon = _param.icon, value = _param.value, children = _param.children, props = _objectWithoutProperties(_param, [
        "icon",
        "value",
        "children"
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_1__/* .Popover */ .J, _objectSpread({}, props, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_1__/* .Popover.Button */ .J.Button, {
                className: "relative flex flex-row w-full relative pl-10 py-3 pr-5 truncate bg-white border-gray-100 border text-left outline-0 ring-0 focus:border-primary focus:outline-0 focus:ring-0",
                children: [
                    icon,
                    ' ',
                    value,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_solid__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: "absolute right-2 top-1/2 -translate-y-1/2 h-5 fill-gray-400"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_1__/* .Popover.Panel */ .J.Panel, {
                className: "z-[50] left-0 top-full w-full w-72 flex-col items-start flex justify-start text-primary-500 bg-white fixed absolute",
                children: children
            })
        ]
    })));
};


/***/ }),

/***/ 1075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ helper_image; }
});

// EXTERNAL MODULE: ./app.config.js
var app_config = __webpack_require__(48387);
;// CONCATENATED MODULE: ./src/components/helper/serialize.js
function serialize(obj, prefix) {
    var str = [];
    var p;
    // eslint-disable-next-line no-restricted-syntax
    for(p in obj){
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(p)) {
            var k = prefix ? "".concat(prefix, "[").concat(p, "]") : p;
            var v = obj[p];
            str.push(v !== null && typeof v === 'object' ? serialize(v, k) : "".concat(encodeURIComponent(k), "=").concat(encodeURIComponent(v)));
        }
    }
    return str.join('&');
}
/* harmony default export */ var helper_serialize = (serialize);

;// CONCATENATED MODULE: ./src/components/helper/image.js


var parse = function(photo, params) {
    var query = params || {};
    if (typeof photo === 'undefined' || !photo) {
        return '';
    }
    var p = photo;
    if (photo.indexOf('yachtsys.com') !== -1) {
        p = photo.replace('https://media.yachtsys.com', '/yachtsys');
    } else if (photo.indexOf('booking-manager.com') !== -1) {
        p = photo.replace('https://www.booking-manager.com', '/mmk');
    } else if (photo.indexOf('ws.nausys.com') !== -1) {
        p = photo.replace('https://ws.nausys.com', '/nausys');
    } else if (photo.indexOf('sednasystem.com') !== -1) {
        p = photo.replace('https://api1.sednasystem.com', '/sedna');
    } else if (photo.indexOf('api.chartercheck.com/fileadmin') !== -1) {
        p = photo.replace('https://api.chartercheck.com/fileadmin', '/fileadmin');
        if (!query.w) {
            query.w = 1500;
        }
    }
    if (/^(f|ht)tps?:\/\//i.test(p) && !/connect\.5-anker\./i.test(p)) {
        return p;
    }
    if (/^(f|ht)tps?:\/\//i.test(p) && /connect\.5-anker\./i.test(p)) {
        return "".concat(p, "?").concat(helper_serialize(params));
    }
    return "".concat(app_config/* default.endpoint */.Z.endpoint + p, "?").concat(helper_serialize(query));
};
/* harmony default export */ var helper_image = (parse);


/***/ }),

/***/ 89388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SEO; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var _components_helper_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1075);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SEO(param) {
    var _description = param.description, description = _description === void 0 ? '' : _description, _author = param.author, author = _author === void 0 ? 'Chartercheck' : _author, _meta = param.meta, meta = _meta === void 0 ? [] : _meta, _title = param.title, title = _title === void 0 ? 'Chartercheck' : _title, _canonicalUrl = param.canonicalUrl, canonicalUrl = _canonicalUrl === void 0 ? '' : _canonicalUrl, _image = param.image, image = _image === void 0 ? '' : _image, _robots = param.robots, robots = _robots === void 0 ? 'index, follow' : _robots;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var pageImage = image ? (0,_components_helper_image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(image.publicUrl) : '';
    var canonicalUrlGen = canonicalUrl || router.asPath.split('?')[0];
    // prepend the base url to the canonical url
    if (canonicalUrlGen.indexOf('http') !== 0) {
        // remove first slash if it exists
        canonicalUrlGen = canonicalUrlGen.replace(/^\//, '');
        canonicalUrlGen = "".concat("https://www.chartercheck.com", "/").concat(canonicalUrlGen);
    }
    var metaData = [
        {
            name: 'robots',
            content: robots
        },
        {
            name: 'description',
            content: description
        },
        {
            property: 'og:site_name',
            content: 'Chartercheck'
        },
        {
            property: 'og:locale',
            content: router.locale
        },
        {
            property: 'og:author',
            content: author
        },
        {
            property: 'og:publisher',
            content: author
        },
        {
            property: 'og:title',
            content: title
        },
        {
            property: 'og:description',
            content: description
        },
        {
            property: 'og:type',
            content: 'website'
        },
        {
            property: 'og:url',
            content: router.asPath
        },
        {
            property: 'og:image',
            content: pageImage
        }, 
    ].filter(function(i) {
        return i.content;
    }).concat(meta);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_2__["default"], {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                /*#__PURE__*/ children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrlGen
            }),
            metaData.map(function(props, k) {
                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", _objectSpread({}, props), "meta-".concat(k));
            }),
            pageImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                href: pageImage
            })
        ]
    }));
};
SEO.defaultProps = {
    meta: [],
    description: ''
};


/***/ }),

/***/ 90647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BoatTypeSelect; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js
var popover = __webpack_require__(86215);
// EXTERNAL MODULE: ./src/components/elements/dropdown.js
var dropdown = __webpack_require__(52800);
// EXTERNAL MODULE: ./src/components/globals/input-wrapper.js
var input_wrapper = __webpack_require__(75565);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./public/assets/icons/anker/type.svg
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgType = function SvgType(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 337.5 209",
    style: {
      enableBackground: "new 0 0 337.5 209"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M6.6 134.5c11.8.8 17.6 5.3 22.6 9.2 4.5 3.4 8.4 6.3 17.1 7.1 8.7.8 12.9-1.6 17.9-4.2 5.8-2.9 12.1-6.3 23.7-5.5 11.8 1.1 17.6 5.3 22.6 9.2 4.5 3.4 8.4 6.3 17.1 7.1 8.7.8 12.9-1.6 17.9-4.2 5.8-2.9 12.1-6.3 23.7-5.5 11.8 1.1 17.6 5.3 22.6 9.2 4.5 3.4 8.4 6.3 17.1 7.1 8.7.8 13.2-1.6 18.2-4.2 5.8-2.9 12.1-6.3 23.7-5.5 11.8 1.1 17.6 5.3 22.6 9.2 4.5 3.4 8.4 6.3 17.1 7.1 8.7.8 12.9-1.6 17.9-4.2 5.8-2.9 12.1-6.3 23.7-5.5 2.6.3 4.7 2.4 4.7 5v-25.8c.3-2.9-1.8-5.5-4.7-5.5-11.8-1.1-18.2 2.4-23.7 5.5-5 2.6-9.5 5-17.9 4.2-8.7-.8-12.6-3.7-17.1-7.1-2.6-2.1-5.5-4.2-9.5-6.1 7.6-9.2 21.6-26.8 32.4-45.5 5.3-9.5 10-19.2 12.1-28.2 1.3 0 2.9 0 4.2.3 2.9 0 5.3-2.1 5.5-5 0-2.9-2.1-5.3-5-5.5-2.9-.3-9.2-.3-9.2-.3-25.5-.5-52.1.8-78.4 3.7 0-.3-.3-.3-.3-.5L197.3 4.3c-1.1-1.8-3.2-2.6-5-2.4L126 9.8h-.3c-.3 0-.5.3-.8.3 0 0-.3 0-.5.3 0 0-.3 0-.3.3L79.4 34.8c-1.6 1.1-2.6 2.6-2.6 4.7v38.7C43.1 86.9 21.6 93.7 21 94c-1.8.5-3.2 2.1-3.4 3.7l-2.9 11.8c-2.4-.8-5-1.1-8.2-1.3-3.2-.3-5.5 1.8-5.8 4.7v26.6-.5c.3-2.6 2.7-4.7 5.9-4.5zM295.9 63c-2.1 5-4.5 10.5-7.6 15.8-34.2 10.5-89.7 20.3-132.8 27.1 11-10.8 43.9-31.4 140.4-42.9zm-106-50.3 24.5 38.9c-19.2 2.4-37.9 5.3-56 8.7l-23.4-41 54.9-6.6zm90.5 79.2c-10.5 16.3-22.6 30.8-27.1 36-.8 0-1.3-.3-2.1-.3-11.8-.8-18.1 2.4-23.7 5.5-5 2.6-9.5 5-18.1 4.2-8.7-.8-12.6-3.7-17.1-7.1-5-3.9-10.8-8.2-22.6-9.2-11.8-1.1-18.2 2.4-23.7 5.5-5 2.6-9.5 5-17.9 4.2-8.7-.8-12.6-3.7-17.1-7.1-.5-.3-.8-.5-1.3-1.1 35-4.3 118.4-16.1 170.7-30.6z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M331.7 171.1c-8.7-.8-12.9 1.6-18.2 4.2-5 2.6-10.5 5.5-20 5.5-1.3 0-2.4 0-3.9-.3-11.8-.8-17.6-5.3-22.6-9.2-4.5-3.4-8.4-6.3-17.1-7.1-8.7-.8-12.9 1.6-18.2 4.2-5.5 2.9-12.1 6.3-23.7 5.5-11.8-1.1-17.6-5.3-22.6-9.2-4.5-3.4-8.4-6.3-17.1-7.1s-12.9 1.6-18.2 4.2c-5.5 2.9-12.1 6.3-23.7 5.5s-17.6-5.3-22.6-9.2c-4.5-3.4-8.4-6.3-17.1-7.1-8.7-.8-12.9 1.6-18.2 4.2-5.5 2.9-12.1 6.3-23.7 5.5-11.8-1.1-17.6-5.3-22.6-9.2-4.5-3.4-8.4-6.3-17.1-7.1-2.6-.3-4.7-2.6-4.7-5.3v25.8c-.3 2.9 1.8 5.3 4.5 5.5 0 .3.3.3.3.3H6c8.2.8 11.8 3.7 16.3 7.1 5 3.9 10.8 8.2 22.6 9.2 11.8 1.1 18.2-2.4 23.7-5.5 5-2.6 9.5-5 18.2-4.2 8.7.8 12.6 3.7 17.1 7.1 5 3.9 10.8 8.2 22.6 9.2 11.8 1.1 18.2-2.4 23.7-5.5 5-2.6 9.5-5 18.2-4.2s12.6 3.7 17.1 7.1c5 3.9 10.8 8.2 22.6 9.2 11.8 1.1 18.2-2.4 23.7-5.5 5-2.6 9.5-5 18.2-4.2 8.7.8 12.6 3.7 17.1 7.1 5 3.9 10.8 8.2 22.6 9.2 1.3 0 2.6.3 3.9.3 9.5 0 15-2.9 20-5.5 4.7-2.6 9.2-4.7 17.1-4.2.3 0 .5.3.8.3 0 0 .3 0 .3-.3 2.9 0 5.3-2.1 5.3-4.7v-26.3c.1 2.9-2.5 5-5.4 4.7z"
  })));
};

/* harmony default export */ var type = (SvgType);
;// CONCATENATED MODULE: ./src/components/search/form/boat-type-select.js






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function BoatTypeSelect(_param) {
    var value1 = _param.value, setValue = _param.setValue, rest = _objectWithoutProperties(_param, [
        "value",
        "setValue"
    ]);
    var ref = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            boat_type_id: value1
        }
    }), control = ref.control, watch = ref.watch;
    watch(function(v) {
        setValue('boat_type_id', v.boat_type_id);
        // @todo workaround, close popover correctly
        document.getElementById('boat-type-apply-button').click();
    });
    var options = [
        {
            label: 'Alle Bootsarten',
            value: ''
        },
        {
            label: 'Segelyachten',
            value: 'in:1,8,15,20,16,31'
        },
        {
            label: 'Motoryachten',
            value: 'in:6,14,24,26,5,9,12,11,18,25,39'
        },
        {
            label: 'Katamarane',
            value: 'in:10,13,17'
        }
    ];
    var getLabelForValue = function(value) {
        var selected = options.find(function(item) {
            return item.value === value;
        });
        if (selected) {
            return selected.label;
        }
        return options[0].label;
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(input_wrapper/* default */.Z, {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(type, {
            className: "absolute right-0 z-10 w-5 h-6 -mt-px pointer-events-none fill-action top-3 left-2"
        }),
        children: [
            ' ',
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                control: control,
                name: "boat_type_id",
                render: function(param) {
                    var _field = param.field, onChange = _field.onChange, value = _field.value;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(dropdown/* default */.Z, _objectSpread({
                        value: "".concat(getLabelForValue(value))
                    }, rest, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-row items-center justify-between w-full px-5 pt-2 pb-1 border-b border-gray-100 lg:border-none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                    className: "text-sm font-semibold",
                                    children: "Bootsart"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "w-full pt-5 lg:pt-0 space-y-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "grid divide-y divide-action",
                                    children: options.map(function(i) {
                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                            className: "transition-all duration-200 px-5 py-2 cursor-pointer ".concat(value === i.value ? 'bg-primary text-action hover:bg-primary-600' : 'bg-gray-50 hover:bg-gray-200'),
                                            onClick: function() {
                                                return onChange(i.value);
                                            },
                                            children: i.label
                                        }, i.label);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-row items-center justify-between w-full py-3 flex-nowrap",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                                    id: "boat-type-apply-button",
                                    className: "w-full mx-3 border border-transparent rounded text-center appearance-none select-none bg-primary-500 text-white hover:text-white hover:bg-action-500 active:bg-action-500 text-sm px-4 h-10",
                                    children: "Ok"
                                })
                            })
                        ]
                    }));
                }
            })
        ]
    }));
};


/***/ }),

/***/ 4541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SearchFormDuration; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87536);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86215);
/* harmony import */ var _elements_dropdown__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52800);
/* harmony import */ var _globals_input_wrapper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75565);
/* harmony import */ var _public_assets_icons_anker_calendar_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55500);






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function SearchFormDuration(_param) {
    var value1 = _param.value, setValue = _param.setValue, rest = _objectWithoutProperties(_param, [
        "value",
        "setValue"
    ]);
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_4__/* .useForm */ .cI)({
        defaultValues: {
            duration: value1
        }
    }), control = ref.control, watch = ref.watch;
    watch(function(v) {
        setValue('duration', v.duration);
        // @todo workaround, close popover correctly
        document.getElementById('duration-apply-button').click();
    });
    var options = [
        {
            label: '1 Woche',
            value: 7
        },
        {
            label: '2 Wochen',
            value: 14
        },
        {
            label: '3 Wochen',
            value: 21
        },
        {
            label: '4 Wochen',
            value: 28
        },
        {
            label: 'Wochenende',
            value: 'weekend'
        },
        {
            label: 'Kurzwoche (3-6 N\xe4chte)',
            value: 'btw:3,6'
        },
        {
            label: 'Verl\xe4ngerte Woche (8-13 N\xe4chte)',
            value: 'btw:8,13'
        }, 
    ];
    var getLabelForValue = function(value) {
        var selected = options.find(function(item) {
            return String(item.value) === String(value);
        });
        if (selected) {
            return selected.label;
        }
        return options[0].label;
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        "data-cy": "duration",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_globals_input_wrapper__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_public_assets_icons_anker_calendar_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: "absolute right-0 z-10 w-5 h-6 -mt-px pointer-events-none fill-action top-3 left-2"
            }),
            children: [
                ' ',
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_hook_form__WEBPACK_IMPORTED_MODULE_4__/* .Controller */ .Qr, {
                    control: control,
                    name: "duration",
                    render: function(param) {
                        var _field = param.field, onChange = _field.onChange, value = _field.value;
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_elements_dropdown__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _objectSpread({
                            value: "".concat(getLabelForValue(value))
                        }, rest, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex flex-row items-center justify-between w-full px-5 pt-2 pb-1 border-b border-gray-100 lg:border-none",
                                    "data-cy": "duration",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                        className: "text-sm font-semibold",
                                        children: "Reisedauer"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-full pt-5 lg:pt-0 space-y-3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                        className: "grid divide-y divide-action",
                                        children: options.map(function(i) {
                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                className: "transition-all duration-200 px-5 py-2 cursor-pointer ".concat(value === i.value ? 'bg-primary text-action hover:bg-primary-600' : 'bg-gray-50 hover:bg-gray-200'),
                                                onClick: function() {
                                                    return onChange(i.value);
                                                },
                                                children: i.label
                                            }, i.label);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex flex-row items-center justify-between w-full py-3 flex-nowrap",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Popover.Button */ .J.Button, {
                                        id: "duration-apply-button",
                                        className: "w-full mx-3 border border-transparent rounded text-center appearance-none select-none bg-primary-500 text-white hover:text-white hover:bg-action-500 active:bg-action-500 text-sm px-4 h-10",
                                        children: "Ok"
                                    })
                                })
                            ]
                        }));
                    }
                })
            ]
        })
    }));
};


/***/ }),

/***/ 90313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ isAdacCustomer; }
/* harmony export */ });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31955);

// eslint-disable-next-line import/prefer-default-export
function isAdacCustomer() {
    return js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get('ref') === 'adac';
}


/***/ }),

/***/ 53536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/helper/seo.js
var seo = __webpack_require__(89388);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/outline/esm/ChevronRightIcon.js
var ChevronRightIcon = __webpack_require__(40169);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/solid/esm/CheckIcon.js


function CheckIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
    clipRule: "evenodd"
  }));
}

const ForwardRef = react.forwardRef(CheckIcon);
/* harmony default export */ var esm_CheckIcon = (ForwardRef);
// EXTERNAL MODULE: ./src/components/elements/button.js
var elements_button = __webpack_require__(81474);
// EXTERNAL MODULE: ./src/components/content/headline.js + 1 modules
var headline = __webpack_require__(17587);
// EXTERNAL MODULE: ./src/components/helper/link.js
var helper_link = __webpack_require__(34892);
;// CONCATENATED MODULE: ./src/components/home/ups/feature.js


function UpsFeature(param) {
    var children = param.children, title = param.title, _description = param.description, description = _description === void 0 ? '' : _description, _className = param.className, className = _className === void 0 ? '' : _className, _variant = param.variant, variant = _variant === void 0 ? 'action' : _variant, _href = param.href, href = _href === void 0 ? '' : _href, _label = param.label, label = _label === void 0 ? '' : _label, _full = param.full, full = _full === void 0 ? false : _full;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "h-full overflow-hidden",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "transition-all duration-500 hover:scale-[102%] ".concat(!full ? 'px-7 py-3' : '', " items-center flex ").concat(variant === 'action' ? 'bg-primary-300 text-white ' : 'bg-action text-primary', " ").concat(className),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-1/3 md:w-1/5 text-action flex justify-center",
                        children: children
                    }),
                    title !== '' && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "ml-2 md:ml-5 block md:text-lg text-center uppercase font-semibold",
                        children: title
                    }),
                    href && label && /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
                        href: href,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "w-full ml-3 md:ml-0 text-center py-2 uppercase font-bold ".concat(variant === 'action' ? 'bg-action text-primary' : 'bg-primary text-white', " ").concat(className),
                            children: label
                        })
                    })
                ]
            }),
            description !== '' && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-gray-100 text-lg p-3 h-full",
                children: description
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/home/ups/feature-right.js

function UpsFeatureRight(param) {
    var children = param.children, title = param.title, description = param.description, _className = param.className, className = _className === void 0 ? '' : _className;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "transition cursor-pointer bg-action-400 hover:bg-action-500 text-primary px-7 py-3 flex-col items-center text-center justify-end flex ".concat(className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "mt-3 block text-center uppercase font-bold text-lg leading-5 mb-3",
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: description
            }),
            children
        ]
    }));
};

;// CONCATENATED MODULE: ./public/images/adac.svg
var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgAdac = function SvgAdac(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 608.9 609.7"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M0 0h608.9v609.7H0Z",
    fill: "#ffcf00"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M29.28 216.6h36.91L74 178.5h41.11l6.82 38.1h45.33l-37.7-184.51H70.8ZM95.47 70.2h.4l13 76.21H80.23Z",
    fill: "#231f1f"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M179.5 216.6h55.16c55.35 0 76.81-44.12 76.81-96.26 0-54.15-26.27-88.25-82.43-88.25H179.5Zm45.73-152.42H229c30.28 0 33.29 34.09 33.29 54.15 0 24.07 0 64.18-32.09 64.18h-5V64.18m80.85 152.42h38.11l8-38.1h42.34l7.22 38.1h46.73L409.34 32.09H349L306.05 216.6Zm68.19-146.4h.61l13.23 76.21H358.6ZM538.1 96.27c0-12-3.21-34.1-19.65-34.1-19.25 0-22.06 28.08-22.06 62.18 0 38.1 1.8 60.16 23.06 60.16 16.85 0 20.66-14 21.66-36.1l39.51 4c0 40.11-23.66 66.18-63.18 66.18-55.35 0-70.39-46.13-70.39-94.26 0-46.13 14.84-96.27 70.39-96.27 43.73 0 63.18 30.08 63.18 68.19Z",
    fill: "#231e1f"
  })));
};

/* harmony default export */ var adac = (SvgAdac);
;// CONCATENATED MODULE: ./public/assets/icons/sicher.svg
var _defs, _g, sicher_path, sicher_path2, _g2, sicher_path3, _path4;

function sicher_extends() { sicher_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return sicher_extends.apply(this, arguments); }



var SvgSicher = function SvgSicher(props) {
  return /*#__PURE__*/react.createElement("svg", sicher_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 375 375"
  }, props), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "sicher_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M13.684 102h347.582v204H13.684Zm0 0"
  })), /*#__PURE__*/react.createElement("clipPath", {
    id: "sicher_svg__b"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M209.617 45.008H340.16v130.539H209.617Zm0 0"
  })))), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#sicher_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M351.195 204.906a22.109 22.109 0 0 0-20.851-2l-12.684 5.32v-50.703a23.845 23.845 0 0 0-1.086-6.933 26.46 26.46 0 0 0 10.328-20.824c-.695-15.075-13.093-26.946-28.16-26.946-15.062 0-27.465 11.871-28.156 26.946.008 1.328.121 2.652.34 3.964H138.53c-13.11.016-23.734 10.66-23.746 23.793v14.973h-45.46v-10.742a4.758 4.758 0 0 0-4.75-4.762H18.433a4.758 4.758 0 0 0-4.75 4.762v133.34a4.755 4.755 0 0 0 4.75 4.758h46.14a4.755 4.755 0 0 0 4.75-4.758v-18.352h49.89l49.938 21.945a85.486 85.486 0 0 0 34.625 7.286h1.391a86.453 86.453 0 0 0 39.102-9.399l105.824-53.992c.105-.05.21-.11.308-.172a22.235 22.235 0 0 0 10.68-18.531 22.243 22.243 0 0 0-9.887-18.969Zm-52.449-92.543c9.938-.328 18.274 7.45 18.66 17.407-.691 9.816-8.84 17.421-18.66 17.421s-17.969-7.605-18.66-17.421c.383-9.958 8.719-17.735 18.66-17.407ZM138.531 143.25h135.88a28.397 28.397 0 0 0 24.335 13.445 29.098 29.098 0 0 0 9.2-1.504c.136.774.206 1.551.214 2.332v54.688l-12.21 5.113v-35.347c-.02-14.633-11.856-26.497-26.466-26.512H162.957c-13.73.015-25.172 10.547-26.352 24.254a31.558 31.558 0 0 0-12.328-6.207v-15.989c.008-7.882 6.387-14.27 14.254-14.273Zm110.598 93.715v-.57c-.016-14.633-11.852-26.493-26.461-26.512h-46.461a22.238 22.238 0 0 1-15.836-6.57l-14.383-14.41v-6.91c.012-9.384 7.606-16.985 16.969-16.99h106.527c9.368.009 16.954 7.61 16.965 16.993v39.32ZM59.824 290.344h-36.64V166.512h36.64Zm285.79-56.156-105.65 53.902a76.926 76.926 0 0 1-34.796 8.363h-1.39a76.066 76.066 0 0 1-30.794-6.469l-50.863-22.355a4.842 4.842 0 0 0-1.902-.399H69.324v-85.218h47.082c.746 0 1.489.035 2.219.11a22.2 22.2 0 0 1 13.605 6.46l21.418 21.461a31.67 31.67 0 0 0 22.551 9.355h46.469c9.363.012 16.953 7.614 16.96 16.997v2.957h-78.96c-6.332 0-6.332 9.515 0 9.515h83.71c.161 0 .313-.031.466-.043.117 0 .226-.02.34-.035a4.854 4.854 0 0 0 1.02-.273h.034l46.785-19.621.04-.016 21.68-9.09h.034l19.235-8.07a12.666 12.666 0 0 1 11.918 1.148 12.704 12.704 0 0 1 5.656 10.574 12.797 12.797 0 0 1-5.973 10.746Zm0 0"
  }))), sicher_path || (sicher_path = /*#__PURE__*/react.createElement("path", {
    d: "M260.71 102.793c7.84 0 14.903-4.73 17.9-11.984a19.45 19.45 0 0 0-4.2-21.157 19.346 19.346 0 0 0-21.117-4.203 19.402 19.402 0 0 0-11.957 17.93c.008 10.719 8.676 19.406 19.375 19.414Zm0-29.305a9.88 9.88 0 0 1 9.126 6.11 9.908 9.908 0 0 1-2.145 10.78 9.858 9.858 0 0 1-10.761 2.145 9.892 9.892 0 0 1-6.098-9.144c0-5.461 4.422-9.895 9.879-9.899Zm0 0"
  })), sicher_path2 || (sicher_path2 = /*#__PURE__*/react.createElement("path", {
    fill: "#103400",
    d: "M275.246 46.938c-35.18 0-63.695 28.519-63.695 63.695 0 35.18 28.515 63.699 63.695 63.699s63.695-28.52 63.695-63.7c0-35.175-28.515-63.695-63.695-63.695"
  })), _g2 || (_g2 = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#sicher_svg__b)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M318.168 67.012c-11.074-11.075-26.371-17.926-43.273-17.926-16.899 0-32.196 6.852-43.27 17.926-11.078 11.074-17.926 26.37-17.926 43.273 0 16.899 6.848 32.2 17.926 43.274 11.074 11.074 26.371 17.921 43.27 17.921 16.902 0 32.199-6.847 43.273-17.921 11.074-11.075 17.926-26.375 17.926-43.274 0-16.902-6.852-32.2-17.926-43.273Zm-43.273-22.004c18.027 0 34.343 7.308 46.16 19.117 11.812 11.816 19.117 28.133 19.117 46.16 0 18.024-7.305 34.344-19.117 46.156-11.817 11.813-28.133 19.121-46.16 19.121-18.024 0-34.344-7.308-46.157-19.12-11.812-11.813-19.12-28.133-19.12-46.157 0-18.027 7.308-34.344 19.12-46.16 11.813-11.809 28.133-19.117 46.157-19.117"
  }))), sicher_path3 || (sicher_path3 = /*#__PURE__*/react.createElement("path", {
    d: "M311.453 73.727c-9.355-9.356-22.281-15.141-36.558-15.141-14.274 0-27.2 5.785-36.555 15.14-9.356 9.356-15.145 22.282-15.145 36.56 0 14.276 5.79 27.198 15.145 36.554 9.355 9.355 22.281 15.144 36.555 15.144 14.277 0 27.203-5.789 36.558-15.144 9.356-9.356 15.14-22.278 15.14-36.555 0-14.277-5.784-27.203-15.14-36.558Zm-36.558-19.223c15.402 0 29.347 6.246 39.44 16.34 10.095 10.094 16.34 24.039 16.34 39.441 0 15.403-6.245 29.348-16.34 39.442-10.093 10.093-24.038 16.335-39.44 16.335-15.403 0-29.348-6.242-39.438-16.335-10.098-10.094-16.34-24.04-16.34-39.442 0-15.402 6.242-29.347 16.34-39.441 10.09-10.094 24.035-16.34 39.438-16.34"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    d: "M281.316 83.973c-4.976 0-9.148 1.199-12.535 3.597-2.015 1.422-3.84 3.442-5.46 6.051-1.657 2.703-2.641 5.266-2.93 7.695h30.32l-1.2 5.95h-29.835a40.6 40.6 0 0 0-.043 1.773c0 2.293.015 3.656.043 4.098h28.62l-1.245 5.965H260.6c1.247 6.78 4.25 11.593 8.985 14.445 3.414 2.047 7.101 3.066 11.078 3.066 5.54 0 9.863-1.457 12.973-4.355v9.148c-3.703 1.73-7.797 2.582-12.274 2.582-13.386 0-22.445-5.57-27.164-16.71-.941-2.258-1.762-4.973-2.441-8.176h-6.801l1.246-5.965h4.672a56.36 56.36 0 0 1-.137-4.051c0-.59.016-1.2.047-1.82h-5.828l1.246-5.95h5.16c1.836-9.668 6.614-16.601 14.356-20.804 4.777-2.61 10.027-3.914 15.777-3.914 5.512 0 10.152 1.199 13.918 3.597l-1.777 8.27c-3.61-2.992-7.723-4.492-12.32-4.492"
  })));
};

/* harmony default export */ var sicher = (SvgSicher);
;// CONCATENATED MODULE: ./public/assets/icons/Berater.svg
var Berater_defs, Berater_g, Berater_g2, _g3, _g4, Berater_path;

function Berater_extends() { Berater_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Berater_extends.apply(this, arguments); }



var SvgBerater = function SvgBerater(props) {
  return /*#__PURE__*/react.createElement("svg", Berater_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 337.5 375"
  }, props), Berater_defs || (Berater_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "Berater_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M24.352 43.379H165V184H24.352Zm0 0"
  })), /*#__PURE__*/react.createElement("clipPath", {
    id: "Berater_svg__b"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M173 43.379h140.102V184H173Zm0 0"
  })), /*#__PURE__*/react.createElement("clipPath", {
    id: "Berater_svg__c"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M173 192h140.102v140.129H173Zm0 0"
  })), /*#__PURE__*/react.createElement("clipPath", {
    id: "Berater_svg__d"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M24.352 192H165v140.129H24.352Zm0 0"
  })))), Berater_g || (Berater_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#Berater_svg__a)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M89.55 173.781a64.52 64.52 0 0 0 29.993-7.36l38.05 16.302a4.62 4.62 0 0 0 2.954.23c.371-.094.726-.23 1.066-.414a4.588 4.588 0 0 0 1.676-1.531 4.56 4.56 0 0 0 .754-2.14 4.676 4.676 0 0 0-.348-2.247l-16.3-38.05a64.52 64.52 0 0 0 7.36-29.992c-.001-1.067-.028-2.134-.08-3.2a67.04 67.04 0 0 0-.628-6.367 66.433 66.433 0 0 0-1.246-6.274 69.282 69.282 0 0 0-.856-3.086 64.29 64.29 0 0 0-2.156-6.023 61.06 61.06 0 0 0-1.297-2.926 65.156 65.156 0 0 0-4.726-8.348 64.318 64.318 0 0 0-1.844-2.617 64.928 64.928 0 0 0-6.266-7.262 61.648 61.648 0 0 0-2.316-2.206 65.144 65.144 0 0 0-13.05-9.191 65.228 65.228 0 0 0-5.786-2.74 67.366 67.366 0 0 0-2.988-1.151 68.956 68.956 0 0 0-3.036-1.004 65.616 65.616 0 0 0-3.085-.852 70.643 70.643 0 0 0-3.122-.703 65.74 65.74 0 0 0-6.332-.938 62.268 62.268 0 0 0-3.191-.234 62.451 62.451 0 0 0-3.2-.078c-1.066 0-2.132.023-3.198.078-1.067.05-2.13.129-3.192.234a66.463 66.463 0 0 0-3.176.391c-1.054.156-2.105.34-3.152.547-1.047.21-2.086.445-3.121.703a64.333 64.333 0 0 0-9.11 3.008 65.224 65.224 0 0 0-16.413 9.836 65.032 65.032 0 0 0-2.422 2.094 58.787 58.787 0 0 0-2.317 2.207 58.787 58.787 0 0 0-2.207 2.316 65.03 65.03 0 0 0-2.094 2.422 64.229 64.229 0 0 0-3.809 5.14 62.885 62.885 0 0 0-3.29 5.488 65.227 65.227 0 0 0-2.736 5.786c-.407.984-.793 1.98-1.153 2.984a64.332 64.332 0 0 0-1.855 6.125 65.478 65.478 0 0 0-.703 3.121 66.433 66.433 0 0 0-.547 3.153 66.463 66.463 0 0 0-.39 3.175 62.268 62.268 0 0 0-.235 3.192 62.45 62.45 0 0 0-.078 3.2c0 1.066.023 2.132.078 3.198.05 1.067.129 2.13.234 3.192a65.74 65.74 0 0 0 .938 6.332c.21 1.047.441 2.086.703 3.12.258 1.036.543 2.063.851 3.087.313 1.02.645 2.031 1.004 3.035.36 1.008.746 2 1.152 2.988a65.227 65.227 0 0 0 2.738 5.785c.5.942 1.028 1.868 1.575 2.782.55.918 1.121 1.816 1.715 2.707a65.142 65.142 0 0 0 23.477 21.277c.94.504 1.894.984 2.859 1.438.965.457 1.937.89 2.926 1.296a64.291 64.291 0 0 0 6.023 2.156c1.02.31 2.05.594 3.086.856a65.443 65.443 0 0 0 9.45 1.637 67.04 67.04 0 0 0 3.19.238c1.067.05 2.133.078 3.2.078Zm0-121.09c1.216 0 2.427.043 3.638.121a56.231 56.231 0 0 1 10.757 1.778 54.94 54.94 0 0 1 3.485 1.055c1.148.386 2.285.812 3.406 1.277a54.823 54.823 0 0 1 6.527 3.207 55.802 55.802 0 0 1 18.485 17.21 57.378 57.378 0 0 1 1.937 3.083 58.817 58.817 0 0 1 1.73 3.203 55.934 55.934 0 0 1 5.879 24.563 56.427 56.427 0 0 1-.421 7.261 58.733 58.733 0 0 1-.567 3.594 54.271 54.271 0 0 1-.797 3.55 56.775 56.775 0 0 1-2.277 6.91 56.243 56.243 0 0 1-3.16 6.555 4.578 4.578 0 0 0-.602 2.044c-.043.73.082 1.43.371 2.101l12.621 29.387-29.386-12.621a5.083 5.083 0 0 0-1.864-.375 4.84 4.84 0 0 0-2.28.605 57.432 57.432 0 0 1-2.825 1.496c-.957.473-1.922.914-2.902 1.332a57.27 57.27 0 0 1-2.977 1.164 56.1 56.1 0 0 1-6.125 1.805 54.11 54.11 0 0 1-6.293 1.098 54.255 54.255 0 0 1-3.18.277 54.536 54.536 0 0 1-3.195.094 54.391 54.391 0 0 1-3.191-.086 54.361 54.361 0 0 1-3.184-.27 57.625 57.625 0 0 1-6.293-1.082 55.215 55.215 0 0 1-3.09-.812 51.964 51.964 0 0 1-3.039-.985 53.875 53.875 0 0 1-2.976-1.156 55.78 55.78 0 0 1-5.735-2.812 57.123 57.123 0 0 1-2.738-1.649 57.07 57.07 0 0 1-2.637-1.8 55.717 55.717 0 0 1-9.398-8.617 55.78 55.78 0 0 1-5.629-7.743 59.054 59.054 0 0 1-1.574-2.781 59.057 59.057 0 0 1-1.41-2.867 57.127 57.127 0 0 1-2.317-5.95 55.152 55.152 0 0 1-.898-3.066 56.084 56.084 0 0 1-.727-3.11 56.973 56.973 0 0 1-.906-6.32 54.406 54.406 0 0 1-.184-3.191 54.465 54.465 0 0 1 0-3.195c.032-1.063.094-2.125.184-3.188.09-1.062.215-2.12.367-3.172.149-1.054.332-2.105.543-3.148.211-1.043.453-2.082.727-3.113a56.02 56.02 0 0 1 1.972-6.07 57.18 57.18 0 0 1 2.657-5.81 57.064 57.064 0 0 1 3.3-5.469 58.029 58.029 0 0 1 1.88-2.581 58.687 58.687 0 0 1 2.023-2.473 55.96 55.96 0 0 1 6.871-6.664 55.147 55.147 0 0 1 5.172-3.75 55.704 55.704 0 0 1 8.469-4.457c.98-.414 1.976-.8 2.98-1.156 1-.356 2.016-.684 3.039-.984 1.02-.297 2.05-.567 3.09-.81a56.831 56.831 0 0 1 6.293-1.081 62.078 62.078 0 0 1 3.183-.27 58.016 58.016 0 0 1 3.192-.086Zm0 0"
  }))), Berater_g2 || (Berater_g2 = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#Berater_svg__b)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M247.898 43.379c-1.066 0-2.132.023-3.199.078-1.066.05-2.129.129-3.191.234a66.463 66.463 0 0 0-3.176.391c-1.055.156-2.105.34-3.152.547-1.047.21-2.09.445-3.125.703a64.181 64.181 0 0 0-6.121 1.855c-1.004.36-2 .747-2.989 1.153-.984.41-1.96.84-2.925 1.297a67.348 67.348 0 0 0-5.641 3.015 67.078 67.078 0 0 0-5.32 3.555c-.86.637-1.7 1.293-2.524 1.969a65.033 65.033 0 0 0-2.422 2.094 65.13 65.13 0 0 0-10.43 12.086c-.59.886-1.16 1.789-1.71 2.703a67.166 67.166 0 0 0-1.578 2.785 65.224 65.224 0 0 0-7.383 24.344 62.267 62.267 0 0 0-.235 3.19 64.327 64.327 0 0 0 1.781 18.645 64.162 64.162 0 0 0 5.497 14.547l-16.301 38.051a4.676 4.676 0 0 0-.105 3.363 4.731 4.731 0 0 0 1.253 1.895 4.698 4.698 0 0 0 2 1.074c.375.094.754.14 1.137.14.633 0 1.238-.124 1.816-.37l38.051-16.301a64.389 64.389 0 0 0 14.551 5.5 64.465 64.465 0 0 0 15.441 1.86c1.067 0 2.133-.028 3.2-.079a67.04 67.04 0 0 0 6.367-.629 66.434 66.434 0 0 0 6.277-1.246 69.118 69.118 0 0 0 3.082-.855 64.52 64.52 0 0 0 8.953-3.453 65.012 65.012 0 0 0 5.641-3.016 60.581 60.581 0 0 0 2.703-1.711 65.145 65.145 0 0 0 16.148-15.375 64.19 64.19 0 0 0 1.844-2.613 67.02 67.02 0 0 0 3.29-5.488c.5-.942.98-1.895 1.437-2.86.457-.965.89-1.941 1.297-2.926.41-.988.793-1.98 1.152-2.988a64.142 64.142 0 0 0 1.856-6.121c.261-1.035.496-2.074.703-3.121a65.738 65.738 0 0 0 1.175-9.524c.051-1.066.079-2.132.079-3.199 0-1.066-.028-2.133-.079-3.2a67.04 67.04 0 0 0-.628-6.366 66.432 66.432 0 0 0-.547-3.153 61.017 61.017 0 0 0-.703-3.12 64.333 64.333 0 0 0-3.008-9.11 61.06 61.06 0 0 0-1.297-2.926 69.803 69.803 0 0 0-1.438-2.86 67.165 67.165 0 0 0-1.578-2.784 64.318 64.318 0 0 0-3.555-5.32 64.929 64.929 0 0 0-8.586-9.469 65.032 65.032 0 0 0-2.421-2.094 65.145 65.145 0 0 0-10.63-7.098 65.085 65.085 0 0 0-2.855-1.441 67.256 67.256 0 0 0-2.925-1.297 69.284 69.284 0 0 0-2.989-1.153 64.181 64.181 0 0 0-6.121-1.855 70.813 70.813 0 0 0-3.125-.703 66.434 66.434 0 0 0-3.152-.547 66.463 66.463 0 0 0-3.176-.39 62.268 62.268 0 0 0-3.191-.235 62.451 62.451 0 0 0-3.2-.078Zm0 121.086a55.55 55.55 0 0 1-14.207-1.856 55.576 55.576 0 0 1-13.27-5.41 4.608 4.608 0 0 0-2.046-.601 4.55 4.55 0 0 0-2.098.37l-29.39 12.622 12.62-29.387a4.55 4.55 0 0 0 .49-2.074c0-.727-.161-1.418-.49-2.07a58.956 58.956 0 0 1-1.421-2.692c-.45-.91-.875-1.832-1.277-2.765a56.85 56.85 0 0 1-2.899-8.657 59.223 59.223 0 0 1-.648-2.972c-.188-1-.348-2-.485-3.008a60.687 60.687 0 0 1-.32-3.028 56.46 56.46 0 0 1 .035-9.124c.086-1.012.2-2.024.344-3.028.14-1.004.309-2.008.504-3.004a58.176 58.176 0 0 1 1.5-5.898 56.809 56.809 0 0 1 2.133-5.703c.406-.93.84-1.848 1.297-2.754a55.486 55.486 0 0 1 4.761-7.79 55.656 55.656 0 0 1 5.96-6.906 50.768 50.768 0 0 1 2.232-2.074 55.679 55.679 0 0 1 2.336-1.953 58.198 58.198 0 0 1 2.441-1.82 58.294 58.294 0 0 1 2.54-1.684c.858-.539 1.733-1.054 2.624-1.543a55.3 55.3 0 0 1 5.48-2.648c.938-.39 1.883-.758 2.84-1.098.957-.34 1.922-.652 2.899-.937a56.052 56.052 0 0 1 8.934-1.86 60.703 60.703 0 0 1 3.03-.289 56.413 56.413 0 0 1 6.086-.086 56.424 56.424 0 0 1 6.063.578c1.004.149 2.004.329 2.996.536a54.425 54.425 0 0 1 5.887 1.554c.965.313 1.922.653 2.871 1.016a56.907 56.907 0 0 1 5.555 2.492 56.895 56.895 0 0 1 5.25 3.082 57.263 57.263 0 0 1 4.882 3.637c.782.648 1.543 1.32 2.286 2.012a56.027 56.027 0 0 1 2.175 2.132c.704.73 1.387 1.48 2.051 2.25.664.766 1.309 1.551 1.93 2.356a54.937 54.937 0 0 1 3.457 5.012 55.3 55.3 0 0 1 2.89 5.355 56.849 56.849 0 0 1 3.207 8.547c.278.976.528 1.96.75 2.95.227.991.422 1.987.594 2.987a55.43 55.43 0 0 1 .688 6.047c.058 1.016.094 2.028.098 3.043a56.64 56.64 0 0 1-.704 9.102c-.16 1-.347 2-.566 2.992a59.281 59.281 0 0 1-.723 2.957c-.27.98-.566 1.95-.886 2.914a55.355 55.355 0 0 1-2.242 5.66 52.03 52.03 0 0 1-1.348 2.73 53.615 53.615 0 0 1-1.496 2.653 51.814 51.814 0 0 1-1.637 2.566 52.809 52.809 0 0 1-1.774 2.477 58.262 58.262 0 0 1-1.906 2.375 55.757 55.757 0 0 1-2.035 2.266 55.659 55.659 0 0 1-11.84 9.5 53.547 53.547 0 0 1-2.652 1.492 52.03 52.03 0 0 1-2.73 1.347c-.922.426-1.856.825-2.801 1.196-.946.375-1.899.722-2.86 1.043-.965.32-1.937.617-2.914.886a55.414 55.414 0 0 1-8.969 1.684 56.498 56.498 0 0 1-3.039.234 52.65 52.65 0 0 1-3.043.067Zm0 0"
  }))), _g3 || (_g3 = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#Berater_svg__c)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M247.898 201.723a64.271 64.271 0 0 0-15.441 1.863 64.192 64.192 0 0 0-14.55 5.496l-38.052-16.3a4.611 4.611 0 0 0-1.332-.34 4.611 4.611 0 0 0-1.37.062c-.454.09-.887.242-1.298.457a4.704 4.704 0 0 0-1.921 1.926c-.215.406-.368.84-.457 1.293-.09.453-.11.91-.063 1.37.047.462.16.907.34 1.333l16.3 38.05a64.192 64.192 0 0 0-5.495 14.551 64.271 64.271 0 0 0-1.782 18.641 66.463 66.463 0 0 0 .625 6.367c.157 1.055.34 2.106.547 3.153.207 1.046.442 2.09.703 3.125a64.18 64.18 0 0 0 1.856 6.12 64.522 64.522 0 0 0 2.449 5.915 69.65 69.65 0 0 0 1.438 2.855 67.166 67.166 0 0 0 1.578 2.785c.55.918 1.12 1.817 1.71 2.703a65.142 65.142 0 0 0 23.48 21.281c.942.5 1.896.981 2.857 1.438a64.52 64.52 0 0 0 8.953 3.453c1.02.309 2.047.594 3.082.852 1.035.262 2.078.496 3.125.703 1.047.207 2.097.39 3.152.547a66.463 66.463 0 0 0 6.367.629c1.067.05 2.133.078 3.2.078 1.066 0 2.132-.027 3.199-.078a67.04 67.04 0 0 0 6.367-.63 66.434 66.434 0 0 0 3.152-.546 61.163 61.163 0 0 0 3.125-.703 64.181 64.181 0 0 0 6.121-1.856 64.52 64.52 0 0 0 5.914-2.449 69.65 69.65 0 0 0 2.856-1.437 67.165 67.165 0 0 0 2.785-1.578 68.621 68.621 0 0 0 2.703-1.711 65.145 65.145 0 0 0 21.281-23.48c.5-.942.98-1.891 1.438-2.856a64.52 64.52 0 0 0 3.453-8.953 64.18 64.18 0 0 0 .852-3.082c.261-1.036.496-2.079.703-3.125.207-1.047.39-2.098.547-3.153a66.462 66.462 0 0 0 .628-6.367c.051-1.066.079-2.133.079-3.2 0-1.066-.028-2.132-.079-3.198a67.04 67.04 0 0 0-.628-6.368 66.432 66.432 0 0 0-.547-3.152 61.162 61.162 0 0 0-.703-3.125 64.181 64.181 0 0 0-1.856-6.121 64.52 64.52 0 0 0-2.45-5.914 72.244 72.244 0 0 0-1.437-2.856 67.165 67.165 0 0 0-1.578-2.785 64.317 64.317 0 0 0-3.555-5.32 65.144 65.144 0 0 0-21.636-18.664c-.942-.5-1.89-.98-2.856-1.438a64.52 64.52 0 0 0-8.953-3.453 64.18 64.18 0 0 0-3.082-.851 61.164 61.164 0 0 0-3.125-.703 66.433 66.433 0 0 0-3.152-.547 66.463 66.463 0 0 0-3.176-.39 62.268 62.268 0 0 0-3.191-.235 62.456 62.456 0 0 0-3.2-.082Zm0 121.09c-1.214 0-2.425-.04-3.636-.122a53.58 53.58 0 0 1-3.621-.359 55.42 55.42 0 0 1-14.024-3.75c-1.125-.46-2.23-.96-3.32-1.496a57.507 57.507 0 0 1-3.211-1.711 57.29 57.29 0 0 1-3.094-1.914 56.992 56.992 0 0 1-5.781-4.414 55.12 55.12 0 0 1-2.664-2.48 57.124 57.124 0 0 1-2.496-2.649 56.992 56.992 0 0 1-2.32-2.805 56.472 56.472 0 0 1-4.063-6.031 52.598 52.598 0 0 1-1.73-3.2 54.912 54.912 0 0 1-1.52-3.308 59.624 59.624 0 0 1-1.3-3.398 57.573 57.573 0 0 1-1.075-3.477 58.24 58.24 0 0 1-.848-3.539 56.341 56.341 0 0 1-1.14-10.844 56.5 56.5 0 0 1 .093-3.636c.07-1.211.18-2.422.332-3.625a55.845 55.845 0 0 1 1.36-7.145c.305-1.176.648-2.34 1.027-3.492a56.84 56.84 0 0 1 2.723-6.746 54.872 54.872 0 0 1 1.687-3.223 4.597 4.597 0 0 0 .485-2.074c0-.727-.16-1.418-.485-2.07l-12.39-29.39 29.39 12.62a4.546 4.546 0 0 0 2.07.488c.731 0 1.423-.16 2.075-.488a56.056 56.056 0 0 1 5.726-2.883 55.424 55.424 0 0 1 6.02-2.207 53.355 53.355 0 0 1 3.098-.843 54.496 54.496 0 0 1 6.309-1.145 58.501 58.501 0 0 1 3.195-.3 58.493 58.493 0 0 1 3.207-.114 58.64 58.64 0 0 1 3.207.066c1.066.055 2.132.141 3.195.254 1.066.117 2.125.262 3.18.438 1.054.176 2.105.379 3.148.617a56.697 56.697 0 0 1 6.164 1.77c1.008.355 2.008.738 2.996 1.148.985.41 1.961.851 2.922 1.316.965.47 1.91.965 2.844 1.485.933.523 1.855 1.07 2.758 1.644a55.483 55.483 0 0 1 2.652 1.801 56.127 56.127 0 0 1 7.29 6.27 56.232 56.232 0 0 1 4.215 4.832 57.67 57.67 0 0 1 1.89 2.59 54.54 54.54 0 0 1 3.324 5.488c.5.945.972 1.902 1.418 2.875a55.551 55.551 0 0 1 3.969 12.176c.214 1.046.398 2.101.546 3.16.153 1.058.278 2.12.368 3.187.09 1.067.152 2.133.183 3.203a58.526 58.526 0 0 1-.004 3.207 54.813 54.813 0 0 1-.187 3.203 54.497 54.497 0 0 1-.922 6.348 53.926 53.926 0 0 1-.73 3.121 55.472 55.472 0 0 1-1.996 6.094c-.391.996-.81 1.98-1.259 2.953a56.096 56.096 0 0 1-3.007 5.664 57.566 57.566 0 0 1-1.746 2.692 55.492 55.492 0 0 1-3.938 5.062c-.703.805-1.43 1.59-2.18 2.352a51.748 51.748 0 0 1-2.308 2.226 61.808 61.808 0 0 1-2.434 2.09 58.556 58.556 0 0 1-2.55 1.945 57.674 57.674 0 0 1-2.66 1.797c-.903.57-1.821 1.117-2.759 1.637a55.848 55.848 0 0 1-5.77 2.797c-.987.41-1.987.789-3 1.14a54.565 54.565 0 0 1-3.058.973 56.481 56.481 0 0 1-3.105.793 57.407 57.407 0 0 1-3.149.613 58.582 58.582 0 0 1-3.18.43 58.166 58.166 0 0 1-3.199.25 58.48 58.48 0 0 1-3.207.063Zm0 0"
  }))), _g4 || (_g4 = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#Berater_svg__d)"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M89.55 332.129c1.067 0 2.134-.027 3.2-.078a67.04 67.04 0 0 0 6.367-.63 65.74 65.74 0 0 0 3.156-.546 61.017 61.017 0 0 0 3.122-.703 64.142 64.142 0 0 0 6.121-1.855c1.007-.36 2-.743 2.988-1.153.984-.406 1.96-.84 2.926-1.297a69.804 69.804 0 0 0 2.86-1.437 67.02 67.02 0 0 0 5.487-3.29 64.19 64.19 0 0 0 2.614-1.843 65.144 65.144 0 0 0 18.664-21.637 65.015 65.015 0 0 0 4.89-11.808c.309-1.02.594-2.047.856-3.082a65.598 65.598 0 0 0 1.637-9.454 67.04 67.04 0 0 0 .238-3.191c.05-1.066.078-2.133.078-3.2a64.465 64.465 0 0 0-1.86-15.44 64.389 64.389 0 0 0-5.5-14.551l16.301-38.051c.18-.426.293-.871.34-1.332a4.61 4.61 0 0 0-1.34-3.77 4.625 4.625 0 0 0-1.101-.82 4.747 4.747 0 0 0-1.297-.457c-.453-.09-.91-.11-1.371-.063-.461.047-.906.16-1.332.34l-38.051 16.301a64.162 64.162 0 0 0-14.547-5.496 64.327 64.327 0 0 0-18.644-1.781c-1.067.05-2.13.129-3.192.234a66.463 66.463 0 0 0-3.176.39c-1.054.157-2.105.34-3.152.548a61.018 61.018 0 0 0-3.121.703 64.332 64.332 0 0 0-9.11 3.007A65.224 65.224 0 0 0 43.45 220.82a58.89 58.89 0 0 0-2.207 2.32 65.031 65.031 0 0 0-2.094 2.423 65.142 65.142 0 0 0-7.097 10.628 67.347 67.347 0 0 0-1.442 2.856 67.257 67.257 0 0 0-1.297 2.926 69.284 69.284 0 0 0-1.152 2.988 64.18 64.18 0 0 0-1.855 6.121 65.634 65.634 0 0 0-1.25 6.277 66.463 66.463 0 0 0-.39 3.176 62.268 62.268 0 0 0-.235 3.192 62.45 62.45 0 0 0-.078 3.199c0 1.066.023 2.133.078 3.199.05 1.066.129 2.129.234 3.191.106 1.063.234 2.122.39 3.176a65.634 65.634 0 0 0 4.258 15.387c.41.984.84 1.96 1.297 2.926.457.965.938 1.914 1.442 2.855a62.885 62.885 0 0 0 3.289 5.488c.59.891 1.207 1.762 1.84 2.618.636.859 1.293 1.699 1.968 2.523.68.824 1.375 1.633 2.094 2.422a65.13 65.13 0 0 0 12.086 10.43c.887.59 1.79 1.16 2.703 1.71a67.165 67.165 0 0 0 2.785 1.579c.942.5 1.895.98 2.86 1.437.965.457 1.937.89 2.926 1.297a64.29 64.29 0 0 0 9.11 3.008c1.034.262 2.073.496 3.12.703 1.047.207 2.098.39 3.152.547a66.463 66.463 0 0 0 6.368.629c1.066.05 2.132.078 3.199.078Zm0-121.09c4.817.008 9.555.625 14.212 1.856a55.642 55.642 0 0 1 13.27 5.41 4.593 4.593 0 0 0 2.07.484c.73 0 1.421-.16 2.074-.484l29.386-12.39-12.62 29.39a4.55 4.55 0 0 0-.372 2.097c.04.73.243 1.41.602 2.047.5.883.976 1.778 1.426 2.688a56.793 56.793 0 0 1 2.398 5.59 56.825 56.825 0 0 1 2.422 8.793 55.26 55.26 0 0 1 .805 6.027 52.76 52.76 0 0 1 .156 3.039c.023 1.016.02 2.031-.012 3.043a52.607 52.607 0 0 1-.172 3.039 55.902 55.902 0 0 1-.343 3.023 55.864 55.864 0 0 1-33.743 43.778c-.937.394-1.882.758-2.836 1.101-.957.34-1.921.653-2.894.942a55.182 55.182 0 0 1-8.926 1.867 56.285 56.285 0 0 1-3.027.297 56.458 56.458 0 0 1-9.117-.106 52.322 52.322 0 0 1-3.024-.367 55.882 55.882 0 0 1-5.957-1.219 58.128 58.128 0 0 1-2.922-.851 58.195 58.195 0 0 1-2.87-1.012 57.103 57.103 0 0 1-5.555-2.477 58.975 58.975 0 0 1-2.669-1.464 54.736 54.736 0 0 1-2.582-1.606 54.928 54.928 0 0 1-2.496-1.746 54.898 54.898 0 0 1-4.68-3.879 56.03 56.03 0 0 1-2.179-2.129 55.873 55.873 0 0 1-2.055-2.242 55.55 55.55 0 0 1-1.933-2.348 58.11 58.11 0 0 1-1.801-2.453 54.777 54.777 0 0 1-1.664-2.547 53.582 53.582 0 0 1-1.527-2.632 58.848 58.848 0 0 1-1.38-2.711 56.817 56.817 0 0 1-3.222-8.532 55.218 55.218 0 0 1-1.793-8.94 56.338 56.338 0 0 1-.273-3.032 56.267 56.267 0 0 1-.106-3.04 56.403 56.403 0 0 1 .063-3.042c.046-1.012.12-2.024.222-3.035.106-1.008.235-2.016.39-3.016a55.226 55.226 0 0 1 1.273-5.95c.267-.98.556-1.952.876-2.913a55.195 55.195 0 0 1 3.559-8.395c.469-.902.965-1.785 1.484-2.656.52-.875 1.063-1.73 1.63-2.574a54.69 54.69 0 0 1 3.66-4.856 53.185 53.185 0 0 1 2.023-2.273 55.817 55.817 0 0 1 2.144-2.156 55.652 55.652 0 0 1 9.652-7.379 60.659 60.659 0 0 1 2.645-1.504 58.845 58.845 0 0 1 2.723-1.356 60.783 60.783 0 0 1 2.793-1.207 58.178 58.178 0 0 1 2.855-1.05c.961-.325 1.93-.622 2.91-.895a50.92 50.92 0 0 1 2.954-.734 55.07 55.07 0 0 1 2.984-.575c1.004-.164 2.008-.3 3.016-.414 1.007-.11 2.02-.191 3.035-.242a56.366 56.366 0 0 1 3.039-.082Zm0 0"
  }))), Berater_path || (Berater_path = /*#__PURE__*/react.createElement("path", {
    d: "M89.55 99.266c.61 0 1.22-.032 1.829-.09a19.053 19.053 0 0 0 1.808-.27 19.127 19.127 0 0 0 3.492-1.059 18.8 18.8 0 0 0 3.223-1.722c.508-.34.996-.703 1.47-1.09a19.132 19.132 0 0 0 2.581-2.582 18.643 18.643 0 0 0 2.809-4.688c.234-.566.441-1.136.617-1.722.176-.582.324-1.176.445-1.773a18.677 18.677 0 0 0 .356-3.633 19.039 19.039 0 0 0-.355-3.637 19.949 19.949 0 0 0-.446-1.773 18.015 18.015 0 0 0-.617-1.72 18.712 18.712 0 0 0-1.719-3.223 19.04 19.04 0 0 0-1.09-1.468 19.16 19.16 0 0 0-2.582-2.582 19.04 19.04 0 0 0-1.469-1.09 18.712 18.712 0 0 0-1.57-.937 16.8 16.8 0 0 0-1.652-.781 18.015 18.015 0 0 0-1.72-.617 19.949 19.949 0 0 0-1.772-.446 19.039 19.039 0 0 0-3.637-.355c-.61 0-1.219.027-1.824.09-.61.058-1.211.148-1.809.265-.598.121-1.191.27-1.773.446-.586.175-1.157.382-1.723.617a18.643 18.643 0 0 0-6.043 4.035c-.43.434-.84.887-1.227 1.355a18.752 18.752 0 0 0-2.813 4.691 17.989 17.989 0 0 0-.612 1.72A17.57 17.57 0 0 0 71.28 77c-.12.602-.21 1.203-.27 1.809-.058.609-.09 1.218-.09 1.828 0 .61.032 1.218.09 1.824.06.61.15 1.21.27 1.809.117.597.266 1.19.446 1.773.175.586.378 1.156.613 1.723.234.562.496 1.113.781 1.652a18.683 18.683 0 0 0 2.031 3.035 18.365 18.365 0 0 0 2.582 2.582 19.04 19.04 0 0 0 3.036 2.031c.539.286 1.09.547 1.652.782a19.204 19.204 0 0 0 3.496 1.058 18.686 18.686 0 0 0 3.633.36Zm0-27.946c.614 0 1.22.059 1.817.18a9.362 9.362 0 0 1 3.36 1.39c.507.34.98.727 1.41 1.16.433.43.82.903 1.16 1.41a9.362 9.362 0 0 1 1.57 5.177c0 .61-.062 1.215-.18 1.816a9.384 9.384 0 0 1-1.39 3.356c-.34.511-.727.98-1.16 1.414a9.381 9.381 0 0 1-3.02 2.02 9.124 9.124 0 0 1-1.75.527 9.122 9.122 0 0 1-1.816.18 9.18 9.18 0 0 1-1.817-.18 9.004 9.004 0 0 1-1.746-.528 9.417 9.417 0 0 1-3.023-2.02 9.137 9.137 0 0 1-1.156-1.413 9.238 9.238 0 0 1-1.57-5.172c0-.614.058-1.219.179-1.817a9.124 9.124 0 0 1 1.39-3.36 9.32 9.32 0 0 1 2.566-2.57 9.397 9.397 0 0 1 5.177-1.57ZM56.95 141.18h65.202a4.573 4.573 0 0 0 1.781-.355c.286-.118.551-.259.805-.43a4.568 4.568 0 0 0 1.285-1.285 4.515 4.515 0 0 0 .695-1.68c.063-.297.09-.602.09-.907v-18.628c0-.918-.09-1.829-.265-2.727a13.993 13.993 0 0 0-8.36-10.184 13.894 13.894 0 0 0-2.62-.793c-.899-.18-1.81-.27-2.723-.27H98.867c-.308 0-.61.032-.91.09-.3.06-.59.15-.871.266a4.538 4.538 0 0 0-1.512 1.008c-.219.219-.41.453-.582.707a4.82 4.82 0 0 0-.43.805 4.816 4.816 0 0 0-.265.875 4.687 4.687 0 0 0-.086.906 4.73 4.73 0 0 1-.356 1.785 4.563 4.563 0 0 1-1.012 1.508 4.563 4.563 0 0 1-1.507 1.012 4.73 4.73 0 0 1-1.785.355 4.69 4.69 0 0 1-1.781-.355 4.82 4.82 0 0 1-.805-.43 4.787 4.787 0 0 1-.707-.582 4.538 4.538 0 0 1-.578-.703 4.61 4.61 0 0 1-.785-2.59 4.69 4.69 0 0 0-.356-1.781 4.55 4.55 0 0 0-.43-.805 4.76 4.76 0 0 0-.578-.707 4.76 4.76 0 0 0-.707-.578 4.55 4.55 0 0 0-.804-.43 4.69 4.69 0 0 0-1.781-.355H66.265c-.918 0-1.825.09-2.727.27a13.788 13.788 0 0 0-5.035 2.086 13.887 13.887 0 0 0-2.117 1.738 14.053 14.053 0 0 0-3.031 4.531 14.278 14.278 0 0 0-.794 2.621c-.18.898-.269 1.809-.269 2.727v18.628a4.69 4.69 0 0 0 .355 1.782c.118.28.262.55.43.804.172.254.363.493.578.707.219.215.453.41.707.579a4.61 4.61 0 0 0 2.586.785Zm4.66-23.285a4.766 4.766 0 0 1 .352-1.781c.116-.286.26-.555.433-.81.167-.253.363-.488.578-.702a4.672 4.672 0 0 1 2.383-1.277c.3-.06.605-.087.91-.087H76.37a13.965 13.965 0 0 0 2.027 3.778c.434.574.907 1.109 1.422 1.613a14.218 14.218 0 0 0 3.5 2.476 13.92 13.92 0 0 0 6.23 1.465c.72 0 1.434-.054 2.145-.164a13.7 13.7 0 0 0 2.094-.492 14.183 14.183 0 0 0 1.992-.809c.645-.32 1.258-.687 1.848-1.105a13.86 13.86 0 0 0 3.074-2.984 13.985 13.985 0 0 0 2.027-3.778h10.11c.305 0 .605.028.906.086.3.063.59.149.875.266.281.117.55.262.805.43a4.773 4.773 0 0 1 1.285 1.285 4.708 4.708 0 0 1 .785 2.59v13.972H61.61ZM247.898 99.266a18.686 18.686 0 0 0 5.406-.805 18.78 18.78 0 0 0 1.723-.613 18.752 18.752 0 0 0 3.223-1.723 18.975 18.975 0 0 0 4.05-3.672c.387-.473.75-.96 1.087-1.469.34-.507.652-1.027.941-1.566a18.74 18.74 0 0 0 1.399-3.375c.175-.582.324-1.176.441-1.773.121-.598.21-1.2.27-1.81.058-.605.09-1.214.09-1.823 0-.61-.032-1.219-.09-1.828a17.875 17.875 0 0 0-.27-1.809 18.663 18.663 0 0 0-.441-1.773 19.154 19.154 0 0 0-.618-1.72 18.752 18.752 0 0 0-4.04-6.047 18.975 18.975 0 0 0-2.82-2.316 18.712 18.712 0 0 0-1.57-.937c-.538-.289-1.09-.55-1.652-.781a17.71 17.71 0 0 0-1.722-.617 19.293 19.293 0 0 0-1.774-.446 18.677 18.677 0 0 0-3.633-.355c-.609 0-1.218.027-1.824.09-.61.058-1.21.148-1.808.265-.602.121-1.192.27-1.774.446a17.71 17.71 0 0 0-1.722.617 17.69 17.69 0 0 0-1.653.781c-.539.285-1.062.602-1.57.938a18.975 18.975 0 0 0-2.82 2.316c-.434.434-.84.887-1.227 1.355a18.752 18.752 0 0 0-2.813 4.691 19.155 19.155 0 0 0-.617 1.72A18.663 18.663 0 0 0 229.63 77c-.121.602-.211 1.203-.27 1.809-.058.609-.09 1.218-.09 1.828 0 .61.032 1.218.09 1.824.059.61.149 1.21.27 1.809a18.373 18.373 0 0 0 1.84 5.148 18.683 18.683 0 0 0 2.031 3.035 18.283 18.283 0 0 0 2.582 2.582c.469.387.961.75 1.465 1.09a18.752 18.752 0 0 0 3.223 1.723c.562.23 1.136.437 1.722.613a18.686 18.686 0 0 0 5.406.805Zm0-27.946c.614 0 1.22.059 1.817.18a9.362 9.362 0 0 1 3.36 1.39c.507.34.976.727 1.41 1.16.433.43.82.903 1.16 1.41a9.362 9.362 0 0 1 1.57 5.177c0 .61-.063 1.215-.18 1.816a9.384 9.384 0 0 1-1.39 3.356 9.294 9.294 0 0 1-2.57 2.57 9.124 9.124 0 0 1-3.36 1.39 9.122 9.122 0 0 1-1.817.18 9.122 9.122 0 0 1-1.816-.18 9.273 9.273 0 0 1-3.36-1.39 9.294 9.294 0 0 1-3.429-4.18 9.384 9.384 0 0 1-.531-1.746 9.478 9.478 0 0 1 0-3.633 9.362 9.362 0 0 1 1.39-3.36c.34-.507.727-.98 1.16-1.41a9.255 9.255 0 0 1 3.023-2.02 9.295 9.295 0 0 1 3.563-.71ZM271.184 103.922h-13.97a4.73 4.73 0 0 0-1.784.355 4.55 4.55 0 0 0-.805.43 4.76 4.76 0 0 0-.707.578 5.018 5.018 0 0 0-.578.707 4.82 4.82 0 0 0-.43.805 4.69 4.69 0 0 0-.355 1.781c0 .309-.028.61-.09.91a4.9 4.9 0 0 1-.262.875c-.117.282-.262.551-.433.805a4.538 4.538 0 0 1-.579.703 4.593 4.593 0 0 1-1.511 1.012 4.872 4.872 0 0 1-.871.265c-.301.059-.606.09-.91.09-.305 0-.61-.031-.91-.09a4.672 4.672 0 0 1-2.96-1.98 4.308 4.308 0 0 1-.431-.805 4.61 4.61 0 0 1-.356-1.785 4.69 4.69 0 0 0-.355-1.781 4.82 4.82 0 0 0-.43-.805 5.018 5.018 0 0 0-.578-.707 4.76 4.76 0 0 0-.707-.578 4.61 4.61 0 0 0-2.586-.785h-13.973c-.918 0-1.828.09-2.726.27a13.788 13.788 0 0 0-5.035 2.086 13.7 13.7 0 0 0-2.118 1.738 13.7 13.7 0 0 0-1.738 2.117 13.788 13.788 0 0 0-1.293 2.414 13.981 13.981 0 0 0-.793 2.621c-.18.898-.27 1.809-.27 2.727v18.628a4.69 4.69 0 0 0 .356 1.782c.117.28.258.55.43.804a4.568 4.568 0 0 0 1.285 1.286c.254.171.523.312.805.43a4.69 4.69 0 0 0 1.781.355H280.5a4.69 4.69 0 0 0 1.781-.356 4.55 4.55 0 0 0 .805-.43 4.568 4.568 0 0 0 1.285-1.285 4.55 4.55 0 0 0 .43-.804 4.69 4.69 0 0 0 .355-1.781v-18.63c0-.917-.09-1.828-.27-2.726a13.697 13.697 0 0 0-.792-2.621 13.788 13.788 0 0 0-1.293-2.414 13.478 13.478 0 0 0-1.738-2.117 13.7 13.7 0 0 0-2.118-1.739 13.788 13.788 0 0 0-2.414-1.293 13.981 13.981 0 0 0-2.62-.793c-.9-.18-1.81-.27-2.727-.27Zm4.66 27.945h-55.89v-13.972c0-.31.03-.61.089-.91a4.777 4.777 0 0 1 .695-1.68c.172-.254.364-.489.582-.703a4.563 4.563 0 0 1 1.508-1.012c.285-.117.574-.203.875-.266.3-.058.602-.086.91-.086h10.106a13.965 13.965 0 0 0 2.027 3.778c.434.574.906 1.109 1.422 1.613.516.5 1.066.957 1.656 1.371.586.418 1.2.785 1.844 1.105a13.81 13.81 0 0 0 4.086 1.3 14.083 14.083 0 0 0 4.289.001 13.81 13.81 0 0 0 2.094-.492 14.183 14.183 0 0 0 1.992-.809c.644-.32 1.258-.687 1.844-1.105.59-.414 1.14-.871 1.656-1.371a13.985 13.985 0 0 0 3.45-5.39h10.105c.308 0 .609.027.91.085.3.063.59.149.875.266a4.563 4.563 0 0 1 1.508 1.012 4.563 4.563 0 0 1 1.011 1.511c.117.282.203.57.266.871.058.301.09.602.09.91ZM89.55 257.613c.61 0 1.22-.031 1.829-.09a20.398 20.398 0 0 0 1.808-.27 19.95 19.95 0 0 0 1.774-.444 18.016 18.016 0 0 0 1.719-.618 16.8 16.8 0 0 0 1.652-.78c.54-.286 1.063-.599 1.57-.938.508-.34.996-.703 1.47-1.09a19.132 19.132 0 0 0 2.581-2.582c.387-.473.75-.961 1.09-1.469a18.74 18.74 0 0 0 2.781-6.715 18.856 18.856 0 0 0 0-7.27 18.481 18.481 0 0 0-1.844-5.148 19.291 19.291 0 0 0-.937-1.566 18.336 18.336 0 0 0-2.32-2.824c-.43-.43-.883-.84-1.352-1.227a19.04 19.04 0 0 0-1.469-1.09 17.716 17.716 0 0 0-1.57-.937c-.535-.29-1.086-.551-1.652-.785a19.127 19.127 0 0 0-3.493-1.06 20.398 20.398 0 0 0-1.808-.269c-.61-.058-1.219-.09-1.828-.09-.61 0-1.219.032-1.824.09-.61.063-1.211.153-1.809.27a19.204 19.204 0 0 0-3.496 1.059c-.563.234-1.113.496-1.652.785-.54.285-1.06.597-1.567.937a19.04 19.04 0 0 0-2.824 2.317c-.43.433-.84.882-1.227 1.355a19.04 19.04 0 0 0-2.03 3.035 18.452 18.452 0 0 0-1.395 3.375 17.57 17.57 0 0 0-.446 1.774c-.12.597-.21 1.203-.27 1.808-.058.606-.09 1.215-.09 1.824 0 .614.032 1.22.09 1.829.06.605.15 1.21.27 1.808.117.598.266 1.188.446 1.774a18.452 18.452 0 0 0 1.394 3.375 19.04 19.04 0 0 0 3.258 4.39c.43.43.883.84 1.355 1.227.473.387.961.75 1.47 1.09.507.34 1.026.652 1.566.937.539.29 1.09.55 1.652.781a18.391 18.391 0 0 0 3.496 1.063c.598.117 1.2.207 1.809.27.605.058 1.214.09 1.824.09Zm0-27.945a9.41 9.41 0 0 1 3.566.707 9.381 9.381 0 0 1 4.18 3.434 9.22 9.22 0 0 1 .86 1.609c.235.566.41 1.148.531 1.746.118.602.18 1.207.18 1.816 0 .614-.062 1.22-.18 1.82a9.474 9.474 0 0 1-.53 1.747 9.35 9.35 0 0 1-3.43 4.18 9.1 9.1 0 0 1-1.61.859 9.136 9.136 0 0 1-1.75.531 9.122 9.122 0 0 1-1.816.18 9.18 9.18 0 0 1-1.817-.18 9.015 9.015 0 0 1-1.746-.531 9.134 9.134 0 0 1-1.613-.86 9.534 9.534 0 0 1-1.41-1.156 9.325 9.325 0 0 1-1.156-1.414 9.238 9.238 0 0 1-1.57-5.176c0-.609.058-1.214.179-1.816a9.171 9.171 0 0 1 1.39-3.355c.34-.508.723-.98 1.157-1.414.433-.43.902-.817 1.41-1.157a9.417 9.417 0 0 1 1.613-.863 9.372 9.372 0 0 1 3.563-.707ZM56.95 299.527h65.202a4.573 4.573 0 0 0 1.781-.355 4.672 4.672 0 0 0 2.524-2.52c.117-.28.203-.574.262-.875.062-.3.09-.601.09-.906v-18.629a13.905 13.905 0 0 0-1.063-5.348 14.215 14.215 0 0 0-1.289-2.417 13.861 13.861 0 0 0-3.855-3.852 13.963 13.963 0 0 0-7.762-2.355H98.867c-.308 0-.61.027-.91.09-.3.058-.59.148-.871.265a4.221 4.221 0 0 0-.809.43 4.538 4.538 0 0 0-.703.578 4.593 4.593 0 0 0-1.011 1.512 4.872 4.872 0 0 0-.266.87c-.059.301-.086.606-.086.91 0 .305-.031.61-.09.91a4.672 4.672 0 0 1-2.785 3.395 4.9 4.9 0 0 1-.875.262c-.3.063-.602.09-.91.09a4.805 4.805 0 0 1-1.781-.352 4.76 4.76 0 0 1-1.512-1.012 4.568 4.568 0 0 1-.578-.706 4.417 4.417 0 0 1-.43-.805 4.573 4.573 0 0 1-.355-1.781 4.573 4.573 0 0 0-.355-1.781 4.417 4.417 0 0 0-.43-.805 4.568 4.568 0 0 0-1.286-1.285 4.308 4.308 0 0 0-.804-.43 4.526 4.526 0 0 0-.875-.266 4.402 4.402 0 0 0-.907-.09H66.266c-.918 0-1.825.09-2.727.266a13.993 13.993 0 0 0-10.184 8.36 14.187 14.187 0 0 0-.792 2.62c-.18.9-.27 1.81-.27 2.727v18.63a4.721 4.721 0 0 0 .355 1.78c.118.282.262.551.43.805.172.254.363.488.578.707.219.215.453.406.707.578a4.61 4.61 0 0 0 2.586.785Zm4.66-23.285c0-.308.027-.61.09-.91a4.9 4.9 0 0 1 .26-.875 4.76 4.76 0 0 1 1.012-1.512 4.672 4.672 0 0 1 3.293-1.363h10.106a13.985 13.985 0 0 0 8.941 8.68c.688.215 1.383.383 2.094.492a14.083 14.083 0 0 0 4.29 0c.71-.11 1.41-.277 2.093-.492a14.183 14.183 0 0 0 1.992-.809 13.833 13.833 0 0 0 3.5-2.48 13.985 13.985 0 0 0 3.45-5.39l10.109-.001a4.721 4.721 0 0 1 1.781.356c.281.117.55.261.805.43.254.171.488.362.707.577.215.22.406.453.578.707a4.61 4.61 0 0 1 .785 2.59v13.969H61.61ZM247.898 257.613c.61 0 1.22-.031 1.825-.09.609-.062 1.21-.152 1.808-.27.602-.12 1.192-.269 1.774-.444a17.71 17.71 0 0 0 1.722-.618 17.69 17.69 0 0 0 1.653-.78c.539-.286 1.062-.599 1.57-.938a18.975 18.975 0 0 0 4.05-3.672 19.335 19.335 0 0 0 2.027-3.035 18.74 18.74 0 0 0 1.4-3.375c.175-.586.324-1.176.441-1.774.121-.597.21-1.203.27-1.808.058-.61.09-1.215.09-1.829 0-.609-.032-1.218-.09-1.824a17.712 17.712 0 0 0-.27-1.808 18.663 18.663 0 0 0-.441-1.774 18.739 18.739 0 0 0-1.398-3.375 19.335 19.335 0 0 0-2.028-3.035c-.39-.473-.797-.922-1.23-1.355a18.975 18.975 0 0 0-2.82-2.316 17.716 17.716 0 0 0-1.571-.938c-.54-.29-1.09-.551-1.653-.785a18.78 18.78 0 0 0-1.722-.614 18.107 18.107 0 0 0-1.774-.445c-.597-.117-1.199-.207-1.808-.27a18.949 18.949 0 0 0-1.825-.09c-.609 0-1.218.032-1.824.09-.61.063-1.21.153-1.808.27a18.78 18.78 0 0 0-3.496 1.059c-.563.234-1.114.496-1.653.785-.539.285-1.062.597-1.57.937a18.975 18.975 0 0 0-2.82 2.317c-.434.433-.84.882-1.227 1.355-.39.473-.75.961-1.09 1.469-.34.508-.652 1.031-.941 1.566a18.74 18.74 0 0 0-1.399 3.375 18.663 18.663 0 0 0-.441 1.774c-.121.597-.211 1.203-.27 1.808-.058.606-.09 1.215-.09 1.824 0 .614.032 1.22.09 1.829.059.605.149 1.21.27 1.808.117.598.266 1.188.441 1.774a18.74 18.74 0 0 0 1.398 3.375c.29.535.602 1.058.942 1.566.34.508.7.996 1.09 1.469a18.282 18.282 0 0 0 2.582 2.582c.469.387.961.75 1.465 1.09.508.34 1.031.652 1.57.937.54.29 1.09.55 1.653.781a17.71 17.71 0 0 0 1.722.618c.582.18 1.172.324 1.774.445.597.117 1.199.207 1.808.27.606.058 1.215.09 1.824.09Zm0-27.945a9.41 9.41 0 0 1 3.566.707 9.381 9.381 0 0 1 4.18 3.434 9.22 9.22 0 0 1 .86 1.609c.234.566.41 1.148.531 1.746.117.602.18 1.207.18 1.816 0 .614-.063 1.22-.18 1.82a9.474 9.474 0 0 1-.531 1.747 9.35 9.35 0 0 1-3.43 4.18 9.1 9.1 0 0 1-1.61.859 9.136 9.136 0 0 1-1.75.531 9.122 9.122 0 0 1-1.816.18 9.122 9.122 0 0 1-1.816-.18 9.015 9.015 0 0 1-1.746-.531 9 9 0 0 1-1.613-.86 9.35 9.35 0 0 1-3.43-4.18 9.474 9.474 0 0 1-.531-1.745 9.488 9.488 0 0 1 0-3.637c.12-.598.297-1.18.531-1.746a9.35 9.35 0 0 1 3.43-4.18 9.273 9.273 0 0 1 5.175-1.57ZM271.184 262.27h-13.97a4.61 4.61 0 0 0-1.785.355 4.76 4.76 0 0 0-1.512 1.008 4.672 4.672 0 0 0-1.363 3.293c0 .304-.027.61-.09.91a4.86 4.86 0 0 1-.26.871c-.118.285-.263.55-.434.805a4.568 4.568 0 0 1-1.286 1.285c-.254.172-.52.316-.804.433a4.86 4.86 0 0 1-.871.262c-.301.063-.606.09-.91.09-.305 0-.61-.027-.91-.09a4.86 4.86 0 0 1-.872-.262 4.435 4.435 0 0 1-.804-.433 4.568 4.568 0 0 1-1.286-1.285 4.19 4.19 0 0 1-.43-.805 4.573 4.573 0 0 1-.355-1.781 4.573 4.573 0 0 0-.355-1.781 4.672 4.672 0 0 0-1.715-2.09 4.308 4.308 0 0 0-.805-.43 4.61 4.61 0 0 0-1.781-.355h-13.973c-.918 0-1.828.09-2.726.265a13.993 13.993 0 0 0-10.184 8.36 13.894 13.894 0 0 0-.793 2.62c-.18.9-.27 1.81-.27 2.727v18.63a4.721 4.721 0 0 0 .356 1.78 4.76 4.76 0 0 0 1.008 1.512c.219.215.453.406.707.578.254.168.523.313.805.43a4.69 4.69 0 0 0 1.781.355H280.5a4.69 4.69 0 0 0 1.781-.355 4.82 4.82 0 0 0 .805-.43c.254-.172.492-.363.707-.578a4.76 4.76 0 0 0 .578-.707 4.55 4.55 0 0 0 .43-.805 4.721 4.721 0 0 0 .355-1.781v-18.629c0-.918-.09-1.828-.27-2.726a13.963 13.963 0 0 0-5.941-8.89 13.993 13.993 0 0 0-5.035-2.09 14.179 14.179 0 0 0-2.726-.266Zm4.66 27.94h-55.89v-13.968a4.73 4.73 0 0 1 .355-1.785 4.82 4.82 0 0 1 .43-.805c.171-.254.363-.488.581-.707.215-.215.45-.406.703-.578a4.61 4.61 0 0 1 2.59-.785h10.106a13.985 13.985 0 0 0 8.941 8.68c.688.215 1.383.383 2.094.492a14.083 14.083 0 0 0 4.289 0c.71-.11 1.406-.277 2.094-.492a14.183 14.183 0 0 0 1.992-.809c.644-.32 1.258-.687 1.844-1.105a13.918 13.918 0 0 0 5.105-6.766h10.106a4.73 4.73 0 0 1 1.785.356c.281.117.55.261.804.43a4.773 4.773 0 0 1 1.286 1.284c.168.254.312.524.43.805a4.73 4.73 0 0 1 .355 1.785Zm0 0"
  })));
};

/* harmony default export */ var Berater = (SvgBerater);
// EXTERNAL MODULE: ./public/assets/icons/Vergleichangebot.svg
var Vergleichangebot = __webpack_require__(38849);
// EXTERNAL MODULE: ./src/lib/app-server-context.js
var app_server_context = __webpack_require__(57806);
;// CONCATENATED MODULE: ./public/assets/icons/f_cart.svg
var f_cart_path;

function f_cart_extends() { f_cart_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return f_cart_extends.apply(this, arguments); }



var SvgFCart = function SvgFCart(props) {
  return /*#__PURE__*/react.createElement("svg", f_cart_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450 430",
    style: {
      enableBackground: "new 0 0 450 430"
    },
    xmlSpace: "preserve"
  }, props), f_cart_path || (f_cart_path = /*#__PURE__*/react.createElement("path", {
    d: "M159.9 308.6h202.3c2.2 0 4.4-.2 6.5-.6 2.2-.4 4.3-.9 6.3-1.6 2.1-.7 4.1-1.6 6-2.6s3.8-2.2 5.5-3.6c1.7-1.3 3.3-2.8 4.8-4.4s2.8-3.3 4.1-5.2c1.2-1.8 2.3-3.7 3.2-5.7.9-2 1.6-4.1 2.2-6.2l47-172.7c.3-1.4.3-2.8 0-4.3-.3-1.4-.9-2.7-1.8-3.8-.9-1-2.1-1.9-3.3-2.5-1.3-.6-2.6-1-4-1.1H91.1L67.3 6.9c-.3-1-.7-1.9-1.2-2.8-.6-.9-1.3-1.6-2.1-2.2-.8-.6-1.7-1.1-2.7-1.4s-2-.4-3-.4H.6v19h50.6l23.2 86.5v.6l47 172.7c.4.9.9 2.1 1.4 3.2l16 59.7c-1.8 1-3.6 2.1-5.2 3.3-1.7 1.2-3.3 2.5-4.8 3.9s-2.9 2.9-4.2 4.5c-1.3 1.6-2.5 3.3-3.5 5.1-1.1 1.8-2 3.6-2.8 5.5s-1.5 3.8-2.1 5.8-1 4-1.3 6-.4 4.1-.5 6.2v9.7h1.1c.3 1.3.6 2.5.9 3.8.4 1.2.8 2.5 1.2 3.7s1 2.4 1.6 3.6 1.2 2.3 1.9 3.4 1.4 2.2 2.1 3.2c.8 1.1 1.6 2.1 2.4 3 .8 1 1.7 1.9 2.7 2.8.9.9 1.9 1.8 2.9 2.6s2 1.6 3.1 2.3l3.3 2.1c1.1.6 2.3 1.2 3.5 1.8l3.6 1.5c1.2.4 2.5.8 3.7 1.1 1.2.3 2.5.6 3.8.8 1.3.2 2.6.4 3.9.5 1.3.1 2.6.2 3.9.2 1.5 0 3-.1 4.5-.2s3-.4 4.5-.7c1.5-.3 3-.7 4.4-1.1 1.5-.4 2.9-.9 4.3-1.5s2.8-1.2 4.1-1.9c1.3-.7 2.6-1.5 3.9-2.3 1.3-.8 2.5-1.7 3.7-2.7s2.3-2 3.4-3c1.1-1.1 2.1-2.2 3.1-3.3 1-1.2 1.9-2.4 2.7-3.6s1.6-2.5 2.4-3.9c.7-1.3 1.4-2.7 2-4.1s1.1-2.8 1.6-4.3c.5-1.4.8-2.9 1.1-4.4s.5-3 .7-4.5.2-3 .3-4.5c-.1-4.9-1-9.6-2.6-14.3-1.6-4.6-3.8-8.9-6.7-12.8h127.8c-2.9 3.9-5.2 8.2-6.7 12.8-1.6 4.6-2.4 9.4-2.6 14.3 0 1.5.1 3 .3 4.5.2 1.5.4 3 .7 4.5s.7 2.9 1.1 4.4c.5 1.4 1 2.9 1.6 4.3s1.2 2.8 2 4.1 1.5 2.6 2.4 3.9c.8 1.2 1.8 2.5 2.7 3.6 1 1.2 2 2.3 3.1 3.3 1.1 1.1 2.2 2.1 3.4 3 1.2 1 2.4 1.9 3.7 2.7 1.3.8 2.6 1.6 3.9 2.3 1.3.7 2.7 1.4 4.1 1.9 1.4.6 2.8 1.1 4.3 1.5 1.4.4 2.9.8 4.4 1.1 1.5.3 3 .5 4.5.7s3 .2 4.5.2c1.3 0 2.6-.1 3.9-.2s2.6-.3 3.9-.5 2.5-.5 3.8-.8 2.5-.7 3.7-1.1 2.4-.9 3.6-1.5c1.2-.5 2.3-1.1 3.5-1.8 1.1-.6 2.2-1.3 3.3-2.1 1.1-.7 2.1-1.5 3.1-2.3s2-1.7 2.9-2.6 1.8-1.8 2.7-2.8c.8-1 1.7-2 2.4-3 .8-1 1.5-2.1 2.1-3.2.7-1.1 1.3-2.2 1.9-3.4.6-1.2 1.1-2.4 1.6-3.6s.9-2.4 1.2-3.7c.4-1.2.7-2.5.9-3.8h1.1v-9.7c0-1.5-.1-3-.2-4.5s-.3-3-.6-4.5-.6-2.9-1.1-4.4c-.4-1.4-.9-2.9-1.5-4.2-.6-1.4-1.2-2.8-1.9-4.1-.7-1.3-1.5-2.6-2.3-3.9s-1.7-2.5-2.7-3.6-1.9-2.3-3-3.3c-1.1-1.1-2.2-2.1-3.3-3-1.2-1-2.4-1.9-3.6-2.7-1.2-.8-2.5-1.6-3.8-2.3-1.3-.7-2.7-1.4-4.1-1.9-1.4-.6-2.8-1.1-4.2-1.5-1.4-.4-2.9-.8-4.4-1.1-1.5-.3-3-.5-4.5-.7s-3-.2-4.5-.2H159.9c-.7 0-1.8.3-3.1.4l-8-29.7c3.6 1 7.3 1.7 11.1 1.7zm0 100.9c-.9 0-1.8-.1-2.7-.2s-1.8-.2-2.6-.4c-.9-.2-1.7-.4-2.6-.7-.8-.3-1.7-.6-2.5-.9s-1.6-.7-2.4-1.2c-.8-.4-1.5-.9-2.3-1.4-.7-.5-1.4-1-2.1-1.6-.7-.6-1.3-1.2-2-1.8-.6-.6-1.2-1.3-1.8-2s-1.1-1.4-1.6-2.2c-.5-.7-.9-1.5-1.4-2.3-.4-.8-.8-1.6-1.1-2.4s-.6-1.7-.9-2.5-.5-1.7-.6-2.6c-.2-.9-.3-1.8-.4-2.6-.1-.9-.1-1.8-.1-2.7 0-.9.1-1.8.1-2.7.1-.9.2-1.8.4-2.6.2-.9.4-1.7.7-2.6s.6-1.7.9-2.5c.3-.8.7-1.6 1.1-2.4s.9-1.5 1.4-2.3c.5-.7 1-1.5 1.6-2.1.6-.7 1.2-1.3 1.8-2 .6-.6 1.3-1.2 2-1.8.7-.6 1.4-1.1 2.1-1.6.7-.5 1.5-1 2.3-1.4s1.6-.8 2.4-1.1c.8-.3 1.7-.6 2.5-.9.9-.3 1.7-.5 2.6-.7.9-.2 1.8-.3 2.6-.4.9-.1 1.8-.1 2.7-.1s1.8 0 2.7.1 1.8.2 2.6.4c.9.2 1.7.4 2.6.6.9.3 1.7.6 2.5.9s1.6.7 2.4 1.1c.8.4 1.6.9 2.3 1.4s1.5 1 2.2 1.6 1.4 1.2 2 1.8c.6.6 1.2 1.3 1.8 2s1.1 1.4 1.6 2.1 1 1.5 1.4 2.3l1.2 2.4c.3.8.7 1.7.9 2.5.3.9.5 1.7.7 2.6s.3 1.8.4 2.6c.1.9.1 1.8.2 2.7 0 .9 0 1.8-.1 2.7l-.3 2.7-.6 2.7c-.2.9-.5 1.7-.9 2.6-.3.8-.7 1.7-1.1 2.5-.4.8-.9 1.6-1.4 2.4s-1 1.5-1.6 2.2-1.2 1.4-1.8 2-1.3 1.3-2 1.8c-.7.6-1.4 1.1-2.2 1.6s-1.5 1-2.4 1.4c-.8.4-1.6.8-2.5 1.1-.8.3-1.7.6-2.6.9s-1.8.5-2.7.6c-.9.2-1.8.3-2.7.3-.9.2-1.8.2-2.7.1zm202.3 0c-.9 0-1.8 0-2.7-.1l-2.7-.3c-.9-.2-1.8-.3-2.6-.6-.9-.2-1.7-.5-2.6-.8-.8-.3-1.7-.7-2.5-1.1s-1.6-.8-2.3-1.3c-.8-.5-1.5-1-2.2-1.6s-1.4-1.1-2-1.8c-.7-.6-1.3-1.3-1.9-2s-1.1-1.4-1.7-2.1c-.5-.7-1-1.5-1.4-2.3l-1.2-2.4c-.4-.8-.7-1.7-1-2.5-.3-.9-.5-1.7-.7-2.6s-.3-1.8-.4-2.7c-.1-.9-.2-1.8-.2-2.7 0-.9 0-1.8.1-2.7l.3-2.7c.2-.9.4-1.8.6-2.6.2-.9.5-1.7.9-2.6s.7-1.7 1.1-2.5.9-1.6 1.3-2.3c.5-.8 1-1.5 1.6-2.2s1.2-1.4 1.8-2c.6-.7 1.3-1.3 2-1.8.7-.6 1.4-1.1 2.1-1.6s1.5-1 2.3-1.4l2.4-1.2c.8-.4 1.7-.7 2.5-.9.9-.3 1.7-.5 2.6-.7s1.8-.3 2.7-.4c.9-.1 1.8-.2 2.7-.2s1.8 0 2.7.1c.9.1 1.8.2 2.7.4.9.2 1.8.4 2.6.6.9.3 1.7.5 2.6.9.8.3 1.7.7 2.4 1.1.8.4 1.6.9 2.3 1.4.8.5 1.5 1 2.2 1.6s1.4 1.2 2 1.8c.6.6 1.2 1.3 1.8 2 .6.7 1.1 1.4 1.6 2.2.5.7 1 1.5 1.4 2.3l1.2 2.4c.4.8.7 1.7.9 2.5.3.9.5 1.7.7 2.6s.3 1.8.4 2.7c.1.9.1 1.8.1 2.7 0 .9 0 1.8-.1 2.7-.1.9-.2 1.8-.3 2.6-.2.9-.3 1.7-.6 2.6-.2.9-.5 1.7-.8 2.5s-.7 1.6-1.1 2.4-.8 1.6-1.3 2.3c-.5.7-1 1.5-1.5 2.2-.6.7-1.1 1.4-1.8 2-.6.6-1.3 1.2-1.9 1.8-.7.6-1.4 1.1-2.1 1.6s-1.5 1-2.3 1.4l-2.4 1.2c-.8.3-1.6.7-2.5.9-.8.3-1.7.5-2.6.7s-1.7.3-2.6.4c-.8.1-1.7.1-2.6.1z"
  })));
};

/* harmony default export */ var f_cart = (SvgFCart);
// EXTERNAL MODULE: ./public/assets/icons/f_phone2.svg
var f_phone2 = __webpack_require__(23364);
// EXTERNAL MODULE: ./app.config.js
var app_config = __webpack_require__(48387);
;// CONCATENATED MODULE: ./src/components/home/booking-options.js












function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function BookingOptions() {
    var useGlobalState = function() {
        return [
            (0,react.useContext)(app_server_context/* GlobalStateContext */.Pn),
            (0,react.useContext)(app_server_context/* DispatchStateContext */.aW), 
        ];
    };
    var ref = _slicedToArray(useGlobalState(), 2), dispatch = ref[1];
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "pt-8 pb-4 container px-4 2xl:px-0",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(headline/* default */.Z, {
                tag: "h2",
                before: "Ihre Buchungs",
                className: "mb-2",
                children: "m\xf6glichkeiten bei CharterCheck"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-8 grid grid-flow-row md:grid-cols-2 gap-5 text-primary-500 md:grid-cols-3",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "search",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UpsFeature, {
                                title: "Online buchen",
                                href: app_config/* default.primarySearchPage */.Z.primarySearchPage,
                                description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-center items-center",
                                    children: [
                                        "Selbst suchen und online buchen",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRightIcon/* default */.Z, {
                                            className: "h-6 text-action"
                                        })
                                    ]
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(f_cart, {
                                    className: "w-full h-16 fill-action"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UpsFeature, {
                            title: "telefonische Beratung",
                            description: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                children: [
                                    "Lassen Sie sich individuell beraten:",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "tel:".concat(app_config/* default.phone */.Z.phone),
                                        className: "font-bold",
                                        children: app_config/* default.phone */.Z.phone
                                    }),
                                    "von Mo-Fr. 9-12 und 16-19 Uhr"
                                ]
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(f_phone2/* default */.Z, {
                                className: "w-full h-16 fill-action"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
                            href: "/kontakt",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UpsFeature, {
                                    title: "Pers\xf6nliches Angebot",
                                    description: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: "Schreiben Sie uns Ihre W\xfcnsche und erhalten Sie innerhalb von 2h ein pers\xf6nlichen Angebot"
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Vergleichangebot/* default */.Z, {
                                        className: "w-full h-16 fill-action"
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/components/home/top-ups.js












function TopFeatures() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "max-w-7xl mx-auto w-full px-6 xl:px-0 pt-8 pb-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col md:grid md:grid-cols-5 mb-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "md:col-span-5 order-2 md:order-1 px-3 md:px-0",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(headline/* default */.Z, {
                            tag: "1",
                            className: "mb-2",
                            after: "Yachtcharter auf allen Weltmeeren",
                            children: [
                                "Chartercheck\xa0-",
                                ' '
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid md:grid-cols-2 gap-10",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-lg text-primary",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: "Chartercheck"
                                                }),
                                                ' ',
                                                "ist eines der f\xfchrenden Buchungsportale f\xfcr Segel- und Motoryachtcharter weltweit. Direkte Verf\xfcgbarkeit von",
                                                ' ',
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: "\xfcber 20.000 Segelyachten, Motoryachten sowie Segel- und Motorkatamarane"
                                                }),
                                                ' ',
                                                "in allen europ\xe4ischen Hotspots wie z.B. Kroatien, Griechenland, Italien oder Spanien. Weltenbummler buchen neben der Karibik viele interessante Destinationen auf allen sieben Weltmeeren bei CharterCheck mit Livedaten. \xdcber unser Portal",
                                                ' ',
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://www.bootsreisen24.de",
                                                    className: "font-bold underline",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: "Bootsreisen24.de"
                                                }),
                                                ' ',
                                                "finden Sie \xfcbrigens weitere 3.000 Hausboote, Yachten und Floating-Houses in Europa und Canada. Als ADAC Mitglied erhalten Sie au\xdferdem auf alle Angebote einen Mitgliedsrabatt, der Ihnen bei der Suche angezeigt und bei der Buchung angerechnet wird."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_button/* default */.Z, {
                                                href: "/ueber-uns",
                                                size: "sm",
                                                width: "w-64",
                                                children: "Warum CharterCheck?"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        className: "space-y-1 text-lg text-primary font-bold ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "bg-primary inline-block mr-4 p-1 rounded-full text-action",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CheckIcon, {
                                                            className: "h-4"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Kooperationspartner des ADAC (Mitgliederrabatt)"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "bg-primary inline-block mr-4 p-1 rounded-full text-action",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CheckIcon, {
                                                            className: "h-4"
                                                        })
                                                    }),
                                                    "Verf\xfcgbarkeiten direkt ansehen und Online buchen"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "bg-primary inline-block mr-4 p-1 rounded-full text-action",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CheckIcon, {
                                                            className: "h-4"
                                                        })
                                                    }),
                                                    "Kostenlose Reservierung f\xfcr Ihre Wunschyacht"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "flex items-center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "bg-primary inline-block mr-4 p-1 rounded-full text-action",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_CheckIcon, {
                                                            className: "h-4"
                                                        })
                                                    }),
                                                    "Preisgarantie"
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BookingOptions, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(headline/* default */.Z, {
                        tag: "h2",
                        after: "Vorteile",
                        className: "mb-2",
                        children: "Unsere"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mt-8 grid grid-flow-row grid-cols-2 gap-2 text-primary-500 md:grid-cols-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UpsFeature, {
                                full: true,
                                description: "lorem ipsum",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(adac, {
                                    className: "w-full -mb-3"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UpsFeature, {
                                title: "\xdcber 500 Berater",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Berater, {
                                    className: "w-full mx-2 md:mx-5 fill-action"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UpsFeature, {
                                title: "Buchen ohne Risiko",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(sicher, {
                                    className: "w-full mx-2 md:mx-5 fill-action"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UpsFeature, {
                                title: "Vergleichs\xadangebot",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Vergleichangebot/* default */.Z, {
                                    className: "w-full mx-2 md:mx-5 fill-action"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UpsFeatureRight, {
                                title: "Warum CharterCheck?",
                                description: "Maecenas faucibus mollis interdum.",
                                className: "col-span-2 md:col-span-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRightIcon/* default */.Z, {
                                    className: "w-14 mt-5"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./src/styles/services.module.css
var services_module = __webpack_require__(57784);
var services_module_default = /*#__PURE__*/__webpack_require__.n(services_module);
;// CONCATENATED MODULE: ./src/components/home/destinations.js





function TopDestinations(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items;
    var classMap = [
        'lg:row-span-3 lg:col-span-2',
        '',
        'lg:row-span-2',
        '',
        '',
        'lg:row-span-2',
        'lg:col-span-2', 
    ];
    var a = items.slice(0, 7);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "pt-4 pb-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "max-w-7xl mx-auto w-full px-6 xl:px-0",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(headline/* default */.Z, {
                    tag: "h2",
                    after: "Reiseziele",
                    className: "mb-4 mt-4",
                    children: "Beliebteste"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-col space-y-4 text-white",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "grid grid-flow-col lg:grid-flow-row grid-rows-1 lg:grid-rows-3 lg:grid-cols-5 gap-4 lg:gap-0.5 overflow-y-hidden overflow-x-auto lg:overflow-hidden lg:h-[500px]",
                        children: a.map(function(item, k) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                                className: "".concat(classMap[k], " w-slider-item h-slider-item lg:w-full lg:h-full text-left overflow-hidden "),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(helper_link/* default */.Z, {
                                    href: item.href,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "relative font-bold flex flex-col items-center justify-end h-full duration-500 ease-in-out transition-spacing group",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "pb-10 ",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "relative  ".concat((services_module_default()).imageWrapper),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                        alt: item.name,
                                                        title: item.name,
                                                        src: item.image,
                                                        layout: "fill",
                                                        objectFit: "cover"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "absolute text-primary z-20 bg-action group-hover:shadow-lg left-0 bottom-0 transition-all px-3 py-2 duration-500 ease-in-out text-center lg:text-left ",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-lg block mb-0 leading-5",
                                                        children: item.name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-sm font-normal",
                                                        children: item.subtext
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }, k);
                        })
                    })
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/elements/date-picker.js
var date_picker = __webpack_require__(11429);
// EXTERNAL MODULE: ./src/components/search/form/boat-type-select.js + 1 modules
var boat_type_select = __webpack_require__(90647);
// EXTERNAL MODULE: ./src/components/elements/checkbox.js
var elements_checkbox = __webpack_require__(99790);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/components/search/form/region.js
var form_region = __webpack_require__(78696);
// EXTERNAL MODULE: ./src/components/search/form/duration.js
var duration = __webpack_require__(4541);
// EXTERNAL MODULE: ./src/utils/defaultDate.js
var defaultDate = __webpack_require__(28091);
;// CONCATENATED MODULE: ./src/components/content/search-line.js













function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SearchLine(param) {
    var sd = param.sd, country = param.country, region = param.region, locationId = param.locationId, boatTypeId = param.boatTypeId, setSd = param.setSd, setCountry = param.setCountry, setRegion = param.setRegion, setLocationId = param.setLocationId, headline = param.headline, _adacDefault = param.adacDefault, adacDefault = _adacDefault === void 0 ? 0 : _adacDefault;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(null), startDate = ref[0], setStartDate = ref[1];
    var ref1 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            sd: '',
            country: '',
            region_id: '',
            location_id: '',
            date_from: (0,defaultDate/* default */.Z)(),
            date_to: '',
            duration: 7,
            adac: adacDefault,
            boat_type_id: boatTypeId,
            channel: app_config/* default.channel */.Z.channel
        }
    }), clearErrors = ref1.clearErrors, errors = ref1.formState.errors, handleSubmit = ref1.handleSubmit, register = ref1.register, getValues = ref1.getValues, setValue = ref1.setValue;
    register('country', {
        required: 'Bitte w\xe4hlen Sie ein Fahrgebiet aus.'
    });
    var onSubmit = function(data) {
        var query = _objectSpread({}, data);
        if (data.date_from !== '' || moment_default()(data.date_from).isValid()) {
            query.date_to = moment_default()(data.date_from).add(3, 'weeks').format('YYYY-MM-DD');
        }
        router.push({
            pathname: app_config/* default.primarySearchPage */.Z.primarySearchPage,
            query: query
        });
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "p-5",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "block font-bold text-lg text-white md:mb-2 px-2 py-1 md:p-0 bg-primary-700 bg-opacity-80 md:bg-transparent",
                children: headline
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                className: "grid md:grid-cols-8 lg:grid-cols-12 items-center bg-action p-1 gap-1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:col-span-8 lg:col-span-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_region/* default */.Z, {
                            setValue: function(v) {
                                setValue('sd', v);
                                setSd(v);
                            },
                            sd: sd,
                            errors: errors,
                            country: country,
                            region: region,
                            locationId: locationId,
                            interacted: function() {
                                return clearErrors('country');
                            },
                            setCountry: function(v) {
                                setValue('country', (v === null || v === void 0 ? void 0 : v.country_id) || '');
                                setCountry(v);
                            },
                            setRegion: function(v) {
                                setValue('region_id', (v === null || v === void 0 ? void 0 : v.region_id) || '');
                                setRegion(v);
                            },
                            setLocationId: function(v) {
                                setValue('location_id', v || '');
                                setLocationId(v);
                            },
                            next: function() {}
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:col-span-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(date_picker/* default */.Z, {
                            inputDate: startDate,
                            setValue: setValue,
                            onDateChange: setStartDate
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:col-span-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(duration/* default */.Z, {
                            value: getValues('duration'),
                            setValue: function(field, value) {
                                return setValue(field, value);
                            },
                            next: function() {}
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:col-span-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(boat_type_select/* default */.Z, {
                            value: getValues('boat_type_id'),
                            setValue: function(field, value) {
                                return setValue(field, value);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:col-span-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_button/* default */.Z, {
                            variant: "primary",
                            width: "w-full",
                            type: "submit",
                            style: {
                                maxHeight: '50px'
                            },
                            children: "Suchen"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sm:col-span-12 mt-2 ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(elements_checkbox/* default */.Z, {
                    value: getValues('adac'),
                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "Ich bin",
                            ' ',
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "ADAC Mitglied"
                            })
                        ]
                    }),
                    name: "adac",
                    setValue: function(v) {
                        setValue('adac', v);
                    }
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/content/swiper-offer-slider.js
var swiper_offer_slider = __webpack_require__(25729);
;// CONCATENATED MODULE: ./src/components/home/early-booking-discount.js


function EarlyBookingDiscount() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "relative lg:mt-[5em]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "xl:col-span-2 p-5 flex flex-col items-center justify-center text-white mb-10",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-red-700 px-2.5 font-bold tracking-widest text-xl md:text-3xl uppercase",
                    children: "bis zu 20%"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-5xl lg:text-8xl mt-3 font-bold text-center tracking-tighter uppercase relative",
                    id: "text-early-booking",
                    children: "Fr\xfchbucher"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-lg lg:text-3xl uppercase text-center",
                    children: "Auf ausgew\xe4hlte Yachten"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                    src: "/assets/images/early-booking-banner/discount.svg",
                    className: "lg:absolute w-[100px] lg:w-[240px] md:right-[20px] lg:right-[-70px] lg:mt-[16em]",
                    alt: "Rabatt",
                    width: 240,
                    height: 240
                })
            ]
        })
    }));
};

// EXTERNAL MODULE: ./src/lib/adac.js
var lib_adac = __webpack_require__(90313);
;// CONCATENATED MODULE: ./src/components/home/index-hero.js




function IndexHero(param) {
    var _withDiscounts = param.withDiscounts, withDiscounts = _withDiscounts === void 0 ? false : _withDiscounts;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "header-image",
        className: "h-[300px] lg:h-[500px] mb-[280px] md:mb-[100px] lg:mb-[50px]",
        children: [
            (0,lib_adac/* isAdacCustomer */.V)() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "h-full w-full shadow-box flex justify-center items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex lg:flex-col gap-5 items-center justify-between lg:justify-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-2xl lg:text-center text-white",
                            children: "In Kooperation mit dem"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                            title: "ADAC Partner",
                            alt: "ADAC Partner",
                            src: "/images/adac.svg",
                            objectFit: "contain",
                            height: 150,
                            width: 150
                        })
                    ]
                })
            }),
            withDiscounts && !(0,lib_adac/* isAdacCustomer */.V)() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center w-full h-full shadow-box",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EarlyBookingDiscount, {})
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./src/pages/index.js











var __N_SSP = true;
function Home(param) {
    var page = param.page;
    var defaultValues = {
        sd: '',
        country: '',
        region_id: '',
        location_id: '',
        duration: 7,
        adac: 0,
        boat_type_id: 'in:1,8,15,20,16,31',
        channel: app_config/* default.channel */.Z.channel
    };
    var ref6 = (0,react.useState)(null), country = ref6[0], setCountry = ref6[1];
    var ref1 = (0,react.useState)(null), region = ref1[0], setRegion = ref1[1];
    var ref2 = (0,react.useState)(defaultValues.location_id), locationId = ref2[0], setLocationId = ref2[1];
    var ref3 = (0,react.useState)(''), sd = ref3[0], setSd = ref3[1];
    var ref4 = (0,react.useState)(defaultValues.boat_type_id), boatTypeId = ref4[0], setBoatTypeId = ref4[1];
    var offerSlider = function() {
        var elementIndex = page.content.colPos0.findIndex(function(e) {
            return e.type === 'menu_card_list';
        });
        if (elementIndex !== -1 && page.content.colPos0[elementIndex].appearance.frameLayout === 'menu-cards-offer-slider') {
            var ref, ref5;
            return (ref = page.content.colPos0[elementIndex]) === null || ref === void 0 ? void 0 : (ref5 = ref.content) === null || ref5 === void 0 ? void 0 : ref5.items;
        }
        return null;
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {
                title: page.meta.title,
                description: page.meta.description,
                image: page.meta.thumbnail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-gray-200 relative mt-header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IndexHero, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "absolute w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "max-w-7xl mx-auto w-full relative top-[-350px] md:top-[-190px] lg:top-[-140px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mx-auto w-full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchLine, {
                                        sd: sd,
                                        country: country,
                                        region: region,
                                        locationId: locationId,
                                        boatTypeId: boatTypeId,
                                        setCountry: setCountry,
                                        setRegion: setRegion,
                                        setLocationId: setLocationId,
                                        setSd: setSd,
                                        setBoatTypeId: setBoatTypeId,
                                        headline: "Finden Sie Ihre perfekte Yacht",
                                        adacDefault: (0,lib_adac/* isAdacCustomer */.V)() ? 1 : 0
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopFeatures, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TopDestinations, {
                items: page.options.destinations
            }),
            offerSlider() !== null && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: "pt-4 pb-8 max-w-7xl mx-auto px-6 py-6 lg:py-4 xl:px-0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(headline/* default */.Z, {
                            tag: "h2",
                            after: "Angebote",
                            className: "mb-2",
                            children: "Top"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_offer_slider/* default */.Z, {
                        items: offerSlider()
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 28091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ defaultDate; }
/* harmony export */ });
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_0__);

function defaultDate() {
    var today = moment__WEBPACK_IMPORTED_MODULE_0___default()();
    var date;
    // month is zero indexed -> month: 3 represents april
    if (today.month() < 2) {
        date = moment__WEBPACK_IMPORTED_MODULE_0___default()({
            month: 3,
            day: 1
        });
    } else if (today.month() < 10) {
        date = moment__WEBPACK_IMPORTED_MODULE_0___default()().add(1, 'month');
    } else {
        date = moment__WEBPACK_IMPORTED_MODULE_0___default()({
            year: today.year() + 1,
            month: 3,
            day: 1
        });
    }
    return date.format('YYYY-MM-DD');
};


/***/ }),

/***/ 57784:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"services_imageWrapper__iynnD"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [141,399,840,501,419,774,888,179], function() { return __webpack_exec__(78581); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);